import {
  Button,
  Checkbox,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  IconButton,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Box } from '@mui/system';
import CryptoJS from 'crypto-js';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// table component
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// other component
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
// react icons
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import { HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight } from 'react-icons/hi';
import {
  MdInfo,
  MdOutlineAdd,
  MdOutlineDocumentScanner,
  MdUpload,
  MdUploadFile
} from 'react-icons/md';
// material icons
import CloseIcon from '@mui/icons-material/Close';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Document, Page as Pages, pdfjs } from 'react-pdf';

import { domainUrl } from '../services/globalApi';
import { CommonApiforJourney } from '../services/JourneyApi';
import ApiErrorMessage from './ApiErrorMessage';

const params = new URL(window.location.href).searchParams;

const userToken = params.get('u');
const companyToken = params.get('c');
const appToken = params.get('a');
const userId = params.get('ui');
const loanId = params.get('li');
const loanTypeid = params.get('lti');

localStorage.setItem('e13ee06b-72e6-4581-86a3-c0a465e63d74', userToken);
localStorage.setItem('e13ee06b-72e6-4581-86a3-c0a465e63d75', companyToken);
localStorage.setItem('e13ee06b-72e6-4581-86a3-c0a465e63d76', appToken);
localStorage.setItem('e13ee06bu-72e6s-4581e-86a3r-c0a465e63d77', userId);
localStorage.setItem('e13ee06bu-72e6s-4581e-86a3r-loanId', loanId);
localStorage.setItem('e13ee06bu-72e6s-4581e-86a3r-loanTypeid', loanTypeid);

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function RecommendationApplication() {
  const [journeyData, setJourneyData] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [getactiveWizardNumber, setGetactiveWizardNumber] = useState(null);
  const [loaderMsg, setLoaderMsg] = useState('Loading... Please wait');
  const [loaderBox, setLoaderBox] = useState(false);
  const [loaderBoxNew, setLoaderBoxNew] = useState(false);
  const [countryListRes, setCountryListRes] = useState({
    allCountry: null,
    allState: [],
    allCity: []
  });

  const [aptokenx, setAptokenx] = useState(null);
  const [docPrevFlag, setDocPrevFlag] = useState({
    flag: false,
    srcPath: null,
    imgaltTag: null,
    contentType: null,
    reviewInd: null
  });
  const [reviewItemData, setReviewItemData] = useState(null);
  const [helperTextMsg, setHelperTextMsg] = useState({ status: false, index: null });
  const [openApiError, setOpenApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    setLoaderBoxNew(true);
    setTimeout(() => {
      setLoaderBoxNew(false);
      const pageCode3 = localStorage.getItem('e13ee06b-72e6-4581-86a3-c0a465e63d76');
      const pageCodeBytes3 = CryptoJS.AES.decrypt(pageCode3, 'appToken');
      const appToken = pageCodeBytes3.toString(CryptoJS.enc.Utf8);
      setAptokenx(appToken);

      if (appToken !== null) {
        loantyprapiFire('journeyOffline', appToken, '', '', '');
      } else {
        const savedApplicationId = localStorage.getItem(`savedApplicationId`);
        if (savedApplicationId !== null) {
          loantyprapiFire('journeyOffline', savedApplicationId, '', '', '');
        } else {
          loantyprapiFire('journeyOffline', null, '', '', '');
        }
      }
      loantyprapiFire('countryList', null, '', '', '');
    }, 300);
  }, []);

  // new code for document url code
  useEffect(() => {
    if (
      window.location.href.split('&')[window.location.href.split('&').length - 1] !== 'all' &&
      window.location.href.split('&')[window.location.href.split('&').length - 1] !== 'document' &&
      window.location.href.split('&')[window.location.href.split('&').length - 1] !== 'review'
    ) {
      if (getactiveWizardNumber !== null) {
        setActiveStep(getactiveWizardNumber);
      }
    }
  }, [getactiveWizardNumber]);

  const loantyprapiFire = async (
    type,
    condition,
    parentIndex,
    childIndex,
    secondaryCardsItemIndex
  ) => {
    const prevSavedData = JSON.parse(localStorage.getItem('apiCredentials'));

    const pageCode2 = localStorage.getItem('e13ee06b-72e6-4581-86a3-c0a465e63d75');
    const pageCodeBytes2 = CryptoJS.AES.decrypt(pageCode2, 'companyToken');
    const companyToken = pageCodeBytes2.toString(CryptoJS.enc.Utf8);

    const pageCode5 = localStorage.getItem('e13ee06bu-72e6s-4581e-86a3r-c0a465e63d77');
    const pageCodeBytes5 = CryptoJS.AES.decrypt(pageCode5, 'userId');
    const userIdToken = pageCodeBytes5.toString(CryptoJS.enc.Utf8);

    const loanIdKey = localStorage.getItem('e13ee06bu-72e6s-4581e-86a3r-loanTypeid');
    const loanIdKeyDyc = CryptoJS.AES.decrypt(loanIdKey, 'loanTypeIdToken');
    const loanIdKeyLoc = loanIdKeyDyc.toString(CryptoJS.enc.Utf8);

    const pageCode = localStorage.getItem('e13ee06b-72e6-4581-86a3-c0a465e63d74');
    const pageCodeBytes = CryptoJS.AES.decrypt(pageCode, 'userToken');
    const userToken = pageCodeBytes.toString(CryptoJS.enc.Utf8);

    let companyIdObj = {
      companyId: aptokenx !== null ? Number(companyToken) : Number(prevSavedData.companyId),
      userId: aptokenx !== null ? Number(userIdToken) : Number(prevSavedData.userId),
      employmentSubTypeId:
        prevSavedData !== null ? prevSavedData.employmentSubTypeId?.employmentSubcategoryId : null,
      employmentTypeId:
        prevSavedData !== null ? prevSavedData.employmentTypeId?.employmentCategoryId : null,
      journeyId: null,
      loanSubTypeId: prevSavedData !== null ? prevSavedData.loanSubTypeId?.loanId : null,
      loanTypeId:
        aptokenx !== null
          ? loanIdKeyLoc !== ''
            ? Number(loanIdKeyLoc)
            : prevSavedData.loanTypeId?.parentLoanId
          : prevSavedData.loanTypeId?.parentLoanId
    };

    let methodName = '';
    let endapiPath = '';
    const token = pageCode !== null ? userToken : prevSavedData.pageCode;

    if (type === 'countryList') {
      companyIdObj.searchLiteral = '';
      companyIdObj.countryId = 101;
      methodName = 'POST';
      endapiPath = 'sa/cscs/country/list';
    } else if (type === 'stateList') {
      companyIdObj.searchLiteral = '';
      companyIdObj.countryId = condition;
      methodName = 'POST';
      endapiPath = 'sa/cscs/state/list';
    } else if (type === 'cityList') {
      companyIdObj.searchLiteral = '';
      companyIdObj.stateId = condition;
      methodName = 'POST';
      endapiPath = 'sa/cscs/city/list';
    } else if (type === 'journeyOffline') {
      if (aptokenx !== null) {
        companyIdObj.editMode = true;
      } else {
        companyIdObj.editMode = false;
      }
      companyIdObj.recommendationId =
        condition !== null ? Number(condition) : aptokenx !== null ? Number(aptokenx) : null;

      methodName = 'POST';
      endapiPath = 'recommendation/fetch-configured-fields';
    } else if (type === 'saveWizard') {
      const prevDataX = journeyData;
      prevDataX.forEach((journeyReqDataItem) => {
        journeyReqDataItem?.selectedCards?.forEach((selectedCardsItem) => {
          if (selectedCardsItem.masterCardModel.cardType.typeCode === 'DOCUMENT') {
            const steps = activeStep + 1;
            setActiveStep(steps);
          } else {
            const savedApplicationId = localStorage.getItem(`savedApplicationId`);

            const pageCode2 = localStorage.getItem('e13ee06b-72e6-4581-86a3-c0a465e63d75');
            const pageCodeBytes2 = CryptoJS.AES.decrypt(pageCode2, 'companyToken');
            const companyToken = pageCodeBytes2.toString(CryptoJS.enc.Utf8);

            const pageCode5 = localStorage.getItem('e13ee06bu-72e6s-4581e-86a3r-c0a465e63d77');
            const pageCodeBytes5 = CryptoJS.AES.decrypt(pageCode5, 'userId');
            const userIdToken = pageCodeBytes5.toString(CryptoJS.enc.Utf8);

            const wizardObj = {
              activeWizardNumber: activeStep + 1,
              recommendationDetailsId: journeyData[activeStep].recommendationDetailsId,
              recommendationId:
                savedApplicationId !== null
                  ? Number(savedApplicationId)
                  : aptokenx !== null
                  ? Number(aptokenx)
                  : null,
              companyId: aptokenx !== null ? Number(companyToken) : Number(prevSavedData.companyId),
              journeyId: journeyData[activeStep].journeyId,
              userId: aptokenx !== null ? Number(userIdToken) : Number(prevSavedData.userId),
              wizardData: {
                isReviewWizard: journeyData[activeStep].isReviewWizard,
                journeyId: journeyData[activeStep].journeyId,
                reviewLayoutId: journeyData[activeStep].reviewLayoutId,
                selectedCards: journeyData[activeStep].selectedCards,
                wizardCode: journeyData[activeStep].wizardCode,
                wizardCurrentSeq: journeyData[activeStep].wizardCurrentSeq,
                wizardDefaultSeq: journeyData[activeStep].wizardDefaultSeq,
                wizardDescription: journeyData[activeStep].wizardDescription,
                wizardId: journeyData[activeStep].wizardId,
                wizardIsActive: journeyData[activeStep].wizardIsActive,
                wizardIsPublish: journeyData[activeStep].wizardIsPublish,
                wizardName: journeyData[activeStep].wizardName
              },
              wizardId: journeyData[activeStep].wizardId
            };

            wizardObj.wizardData.selectedCards.forEach((selectedCardsItems) => {
              selectedCardsItems.selectedFields.forEach((selectedFieldsItems) => {
                if (
                  selectedFieldsItems.storedField !== null &&
                  selectedFieldsItems.storedField !== '' &&
                  selectedFieldsItems.storedField !== undefined
                ) {
                  selectedFieldsItems.storedField.options = [];
                }
              });

              if (selectedCardsItems.secondaryCards !== null) {
                selectedCardsItems.secondaryCards.forEach((secondaryCardsItems) => {
                  secondaryCardsItems.selectedFields.forEach((selectedFieldsItems) => {
                    if (
                      selectedFieldsItems.storedField !== null &&
                      selectedFieldsItems.storedField !== '' &&
                      selectedFieldsItems.storedField !== undefined
                    ) {
                      selectedFieldsItems.storedField.options = [];
                    }
                  });
                });
              }
            });

            companyIdObj = wizardObj;
            methodName = 'POST';
            endapiPath = 'recommendation/save-wizard-data';
          }
        });
      });
    } else if (type === 'uploadDocument') {
      const savedApplicationId = localStorage.getItem(`savedApplicationId`);

      const pageCode2 = localStorage.getItem('e13ee06b-72e6-4581-86a3-c0a465e63d75');
      const pageCodeBytes2 = CryptoJS.AES.decrypt(pageCode2, 'companyToken');
      const companyToken = pageCodeBytes2.toString(CryptoJS.enc.Utf8);

      const pageCode5 = localStorage.getItem('e13ee06bu-72e6s-4581e-86a3r-c0a465e63d77');
      const pageCodeBytes5 = CryptoJS.AES.decrypt(pageCode5, 'userId');
      const userIdToken = pageCodeBytes5.toString(CryptoJS.enc.Utf8);

      const prevData = journeyData;
      const formData = new FormData();
      formData.append('journeyId', prevData[condition].journeyId);
      formData.append('userId', pageCode5 !== null ? userIdToken : prevSavedData.userId);
      formData.append('wizardId', prevData[condition].wizardId);
      formData.append('activeWizardNumber', activeStep);
      formData.append(
        'companyId',
        aptokenx !== null ? Number(companyToken) : prevSavedData.companyId
      );

      if (prevData[condition].recommendationDetailsId !== null) {
        formData.append(
          'recommendationDetailsId',
          Number(prevData[condition].recommendationDetailsId)
        );
      }

      formData.append(
        'recommendationId',
        savedApplicationId !== null
          ? Number(savedApplicationId)
          : aptokenx !== null
          ? Number(aptokenx)
          : null
      );

      formData.append(
        'journeyCardId',
        prevData[condition].selectedCards[parentIndex].journeyCardId
      );

      if (secondaryCardsItemIndex !== '' && childIndex !== '') {
        formData.append(
          'document1',
          prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
            .selectedFields[childIndex].file
        );

        if (
          prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
            .selectedFields[childIndex].fileBack !== null
        ) {
          formData.append(
            'document2',
            prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
              .selectedFields[childIndex].fileBack
          );
        }
        formData.append(
          'cardDetailId',
          prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
            .selectedFields[childIndex].cardDetailId
        );

        if (
          prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
            .uniqueIdentifierInformation !== null
        ) {
          formData.append(
            'existingUniqueIdentifier',
            prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
              .uniqueIdentifierInformation
          );
        }

        formData.append('isSecondaryCard', true);
      } else if (secondaryCardsItemIndex !== '' && childIndex === '') {
        formData.append(
          'din',
          prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
            .staticFieldValues.din
        );
        formData.append(
          'directorEmail',
          prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
            .staticFieldValues.email
        );
        formData.append(
          'directorName',
          prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
            .staticFieldValues.name
        );
        formData.append(
          'existingUniqueIdentifier',
          prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
            .uniqueIdentifierInformation !== undefined &&
            prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
              .uniqueIdentifierInformation !== null &&
            prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
              .uniqueIdentifierInformation !== ''
            ? prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
                .uniqueIdentifierInformation
            : prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
                .staticFieldValues.mobile
        );
        formData.append(
          'newUniqueIdentifier',
          prevData[condition].selectedCards[parentIndex].secondaryCards[secondaryCardsItemIndex]
            .staticFieldValues.mobile
        );
        formData.append('isSecondaryCard', true);
      } else if (secondaryCardsItemIndex === '' && childIndex !== '') {
        formData.append(
          'document1',
          prevData[condition].selectedCards[parentIndex].selectedFields[childIndex].file
        );

        if (
          prevData[condition].selectedCards[parentIndex].selectedFields[childIndex].fileBack !==
          null
        ) {
          formData.append(
            'document2',
            prevData[condition].selectedCards[parentIndex].selectedFields[childIndex].fileBack
          );
        }
        formData.append(
          'cardDetailId',
          prevData[condition].selectedCards[parentIndex].selectedFields[childIndex].cardDetailId
        );
        formData.append('isSecondaryCard', false);
      } else {
        formData.append(
          'din',
          prevData[condition].selectedCards[parentIndex].staticFieldValues.din
        );
        formData.append(
          'directorEmail',
          prevData[condition].selectedCards[parentIndex].staticFieldValues.email
        );
        formData.append(
          'directorName',
          prevData[condition].selectedCards[parentIndex].staticFieldValues.name
        );
        formData.append(
          'existingUniqueIdentifier',
          prevData[condition].selectedCards[parentIndex].uniqueIdentifierInformation !==
            undefined &&
            prevData[condition].selectedCards[parentIndex].uniqueIdentifierInformation !== null &&
            prevData[condition].selectedCards[parentIndex].uniqueIdentifierInformation !== ''
            ? prevData[condition].selectedCards[parentIndex].uniqueIdentifierInformation
            : prevData[condition].selectedCards[parentIndex].staticFieldValues.mobile
        );
        formData.append(
          'newUniqueIdentifier',
          prevData[condition].selectedCards[parentIndex].staticFieldValues.mobile
        );
        formData.append('isSecondaryCard', false);
      }

      methodName = 'PUT';
      endapiPath = 'recommendation/save-director-details';
      loanTypebycompany(
        type,
        methodName,
        endapiPath,
        formData,
        token,
        'formdata',
        condition,
        parentIndex,
        childIndex,
        secondaryCardsItemIndex
      );
    } else if (type === 'deleteDocument') {
      const savedApplicationId = localStorage.getItem(`savedApplicationId`);

      companyIdObj.recommendationDetailsId = journeyData[activeStep].recommendationDetailsId;
      companyIdObj.recommendationId =
        savedApplicationId !== null
          ? Number(savedApplicationId)
          : aptokenx !== null
          ? Number(aptokenx)
          : null;

      if (condition !== null && condition !== '' && condition !== undefined) {
        companyIdObj.cardDetailId = condition;
      }

      if (parentIndex !== null && parentIndex !== '' && parentIndex !== undefined) {
        companyIdObj.uniqueIdentifier = parentIndex;
      }

      companyIdObj.journeyCardId = childIndex;

      methodName = 'POST';
      endapiPath = 'recommendation/removeDocument';
    } else if (type === 'reviewEditUpdate') {
      const savedApplicationId = localStorage.getItem(`savedApplicationId`);
      const prevSavedData = JSON.parse(localStorage.getItem('apiCredentials'));
      const pageCode2 = localStorage.getItem('e13ee06b-72e6-4581-86a3-c0a465e63d75');
      const pageCodeBytes2 = CryptoJS.AES.decrypt(pageCode2, 'companyToken');
      const companyToken = pageCodeBytes2.toString(CryptoJS.enc.Utf8);
      const pageCode5 = localStorage.getItem('e13ee06bu-72e6s-4581e-86a3r-c0a465e63d77');
      const pageCodeBytes5 = CryptoJS.AES.decrypt(pageCode5, 'userId');
      const userIdToken = pageCodeBytes5.toString(CryptoJS.enc.Utf8);

      const selectedFieldsArray = [];
      if (condition !== null && condition.length > 0) {
        condition.forEach((element, index) => {
          selectedFieldsArray.push({
            cardDetailId: element.cardDetail?.cardDetailId,
            journeyCardId: element.cardDetail?.journeyCardId,
            updatedValue: element.cardDetail?.storedField?.value,
            isEdited:
              element.cardDetail?.isEdited &&
              element.cardDetail?.isEdited !== null &&
              element.cardDetail?.isEdited !== undefined
                ? element.cardDetail?.isEdited
                : false
          });

          const wizardObj1 = {
            recommendationId:
              savedApplicationId !== null
                ? Number(savedApplicationId)
                : aptokenx !== null
                ? Number(aptokenx)
                : null,
            companyId: aptokenx !== null ? Number(companyToken) : Number(prevSavedData.companyId),
            userId: aptokenx !== null ? Number(userIdToken) : Number(prevSavedData.userId),
            selectedFields: selectedFieldsArray
          };
          companyIdObj = wizardObj1;
          methodName = 'PUT';
          endapiPath = 'recommendation/update-selected-fields';
        });
      }
    } else if (type === 'finish') {
      const savedApplicationId = localStorage.getItem(`savedApplicationId`);
      const prevSavedData = JSON.parse(localStorage.getItem('apiCredentials'));
      const pageCode2 = localStorage.getItem('e13ee06b-72e6-4581-86a3-c0a465e63d75');
      const pageCodeBytes2 = CryptoJS.AES.decrypt(pageCode2, 'companyToken');
      const companyToken = pageCodeBytes2.toString(CryptoJS.enc.Utf8);
      const pageCode5 = localStorage.getItem('e13ee06bu-72e6s-4581e-86a3r-c0a465e63d77');
      const pageCodeBytes5 = CryptoJS.AES.decrypt(pageCode5, 'userId');
      const userIdToken = pageCodeBytes5.toString(CryptoJS.enc.Utf8);

      const wizardObj = {
        recommendationId:
          savedApplicationId !== null
            ? Number(savedApplicationId)
            : aptokenx !== null
            ? Number(aptokenx)
            : null,
        companyId: aptokenx !== null ? Number(companyToken) : Number(prevSavedData.companyId),

        userId: aptokenx !== null ? Number(userIdToken) : Number(prevSavedData.userId)
      };

      companyIdObj = wizardObj;
      methodName = 'POST';
      endapiPath = 'offline-v2/finish-loan-application';
    }
    if (type !== 'uploadDocument') {
      loanTypebycompany(
        type,
        methodName,
        endapiPath,
        JSON.stringify(companyIdObj),
        token,
        '',
        condition,
        parentIndex,
        childIndex,
        secondaryCardsItemIndex
      );
    }
  };

  const loanTypebycompany = async (
    type,
    method,
    endpoint,
    credentials,
    authToken,
    frmData,
    condition,
    parentIndex,
    childIndex,
    secondaryCardsItemIndex
  ) => {
    if (type === 'uploadDocument' && secondaryCardsItemIndex !== '' && childIndex !== '') {
      handleClose(condition, parentIndex, childIndex, secondaryCardsItemIndex);
    } else if (type === 'uploadDocument' && secondaryCardsItemIndex === '' && childIndex !== '') {
      handleClose(condition, parentIndex, childIndex, secondaryCardsItemIndex);
    }
    setLoaderBoxNew(true);
    const responseData = await CommonApiforJourney(
      method,
      endpoint,
      credentials,
      authToken,
      frmData
    );
    if (responseData.status === 'success' || responseData.action_status === 'success') {
      const prevSavedData = JSON.parse(localStorage.getItem('apiCredentials'));
      setLoaderBoxNew(false);
      if (type === 'countryList') {
        if (responseData.data.length > 0) {
          const prevData = countryListRes;
          prevData.allCountry = responseData.data;
          setCountryListRes({ ...countryListRes });
          responseData.data.forEach((countryItem) => {
            loantyprapiFire('stateList', countryItem.countryId, '', '', '');
          });
        }
      } else if (type === 'stateList') {
        if (responseData.data.length > 0) {
          const prevData = countryListRes;
          const credentialsObj = JSON.parse(credentials);
          const countryNameList = { [credentialsObj.countryId]: responseData.data };
          prevData.allState.push(countryNameList);
          setCountryListRes({ ...countryListRes });
          responseData.data.forEach((stateItem) => {
            loantyprapiFire('cityList', stateItem.stateId, '', '', '');
          });
        }
      } else if (type === 'cityList') {
        if (responseData.data.length > 0) {
          const prevData = countryListRes;
          const credentialsObj = JSON.parse(credentials);
          const countryNameList = { [credentialsObj.stateId]: responseData.data };
          prevData.allCity.push(countryNameList);
          setCountryListRes({ ...countryListRes });
        }
      } else if (type === 'journeyOffline') {
        setGetactiveWizardNumber(responseData.data.journeyConfigs.activeWizardNumber);
        let journeyReviewCombineData = [];
        journeyReviewCombineData = responseData.data.journeyConfigs.journeyModel.journeyWizards;
        if (responseData.data.journeyConfigs.journeyModel.journeyReviewWizard !== null) {
          journeyReviewCombineData.push(
            responseData.data.journeyConfigs.journeyModel.journeyReviewWizard
          );
        }
        if (journeyReviewCombineData.length > 0) {
          journeyReviewCombineData.forEach((wizardItem, wizardItemIndex) => {
            if (wizardItem.selectedCards !== null && wizardItem.selectedCards !== undefined) {
              wizardItem.selectedCards.forEach((item, cardIndex) => {
                /* ------ new code -------- */
                if (
                  item.masterCardModel.cardType.typeCode === 'DOCUMENT' &&
                  (item?.cardPurpose?.cardPurposeCode === 'DIRECTOR' ||
                    item?.cardPurpose?.cardPurposeCode === 'PARTNER' ||
                    item?.cardPurpose?.cardPurposeCode === 'PROMOTER')
                ) {
                  if (
                    item.staticFieldValues !== null &&
                    item.staticFieldValues !== undefined &&
                    item.staticFieldValues !== ''
                  ) {
                    if (Object.keys(item.staticFieldValues).length > 0) {
                      item.isCardDisable = false;
                    } else {
                      item.isCardDisable = true;
                    }

                    item.staticFieldValues = {
                      name:
                        Object.keys(item.staticFieldValues).length > 0
                          ? item.staticFieldValues.name
                          : null,
                      din:
                        Object.keys(item.staticFieldValues).length > 0
                          ? item.staticFieldValues.din
                          : null,
                      mobile:
                        Object.keys(item.staticFieldValues).length > 0
                          ? item.staticFieldValues.mobile
                          : null,
                      prevmobile:
                        Object.keys(item.staticFieldValues).length > 0
                          ? item.staticFieldValues.mobile
                          : null,
                      email:
                        Object.keys(item.staticFieldValues).length > 0
                          ? item.staticFieldValues.email
                          : null
                    };
                  }
                }

                if (item.secondaryCards !== undefined && item.secondaryCards === null) {
                  item.secondaryCards = [];
                }

                item.selectedFields.forEach((fieldsItem, fieldsIndex) => {
                  if (item.masterCardModel.cardType.typeCode === 'DOCUMENT') {
                    fieldsItem.isOpen = false;
                    fieldsItem.isDocumentSubmit = true;
                    fieldsItem.isOpenPopUp = false;
                    fieldsItem.selectedFieldData = null;
                    fieldsItem.fileBack = null;
                    fieldsItem.kycInputBack = null;
                    fieldsItem.file = null;
                    fieldsItem.kycInput = null;
                    fieldsItem.kycPassProcted = 'No';
                    fieldsItem.isProvideLater = false;
                    fieldsItem.isUnableToSubmit = false;
                    fieldsItem.remarks = null;

                    if (fieldsItem?.storedField !== null) {
                      if (
                        fieldsItem?.storedField?.documentMap !== null &&
                        fieldsItem?.storedField?.documentMap !== '' &&
                        fieldsItem?.storedField?.documentMap !== undefined &&
                        Object.keys(fieldsItem?.storedField?.documentMap).length !== 0
                      ) {
                        responseData.data.journeyConfigs.journeyModel.journeyWizards[
                          wizardItemIndex
                        ].selectedCards[cardIndex].selectedFields[
                          fieldsIndex
                        ].isDocumentSubmit = false;
                        Object.values(fieldsItem?.storedField?.documentMap).map(
                          (docItem, docIndex) => (docItem.isDocumentSubmit = true)
                        );
                      }
                    }
                  }

                  if (
                    fieldsItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldCode === 'COUNTRY'
                  ) {
                    if (fieldsItem?.storedField !== null) {
                      fieldsItem.storedField.options = countryListRes.allCountry;
                    }
                  } else if (
                    fieldsItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldCode === 'STATE'
                  ) {
                    if (fieldsItem?.storedField !== null) {
                      if (fieldsItem?.storedField?.value !== null) {
                        const getStateId = fieldsItem?.storedField?.value;
                        countryListRes?.allState?.forEach((allStateItem) => {
                          if (allStateItem[getStateId.countryId] !== undefined) {
                            fieldsItem.storedField.options = allStateItem[getStateId.countryId];
                          }
                        });
                        setTimeout(() => {
                          countryListRes?.allState?.forEach((allStateItem) => {
                            if (allStateItem[getStateId.countryId] !== undefined) {
                              fieldsItem.storedField.options = allStateItem[getStateId.countryId];
                            }
                          });
                        }, 1000);
                      }
                    }
                  } else if (
                    fieldsItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldCode === 'CITY'
                  ) {
                    if (fieldsItem?.storedField !== null) {
                      if (fieldsItem?.storedField?.value !== null) {
                        const getStateId = fieldsItem?.storedField?.value;
                        countryListRes.allCity.forEach((allStateItem) => {
                          if (allStateItem[getStateId.stateId] !== undefined) {
                            fieldsItem.storedField.options = allStateItem[getStateId.stateId];
                          }
                        });
                        setTimeout(() => {
                          countryListRes.allCity.forEach((allStateItem) => {
                            if (allStateItem[getStateId.stateId] !== undefined) {
                              fieldsItem.storedField.options = allStateItem[getStateId.stateId];
                            }
                          });
                        }, 2000);
                      }
                    }
                  }
                });

                if (item.secondaryCards !== null && item.secondaryCards !== undefined) {
                  item.secondaryCards.forEach((secondaryCardsItems, secondaryCardsIndex) => {
                    if (
                      item.masterCardModel.cardType.typeCode === 'DOCUMENT' &&
                      (item?.cardPurpose?.cardPurposeCode === 'DIRECTOR' ||
                        item?.cardPurpose?.cardPurposeCode === 'PARTNER' ||
                        item?.cardPurpose?.cardPurposeCode === 'PROMOTER')
                    ) {
                      if (
                        secondaryCardsItems.staticFieldValues !== null &&
                        secondaryCardsItems.staticFieldValues !== undefined &&
                        secondaryCardsItems.staticFieldValues !== ''
                      ) {
                        if (Object.keys(secondaryCardsItems.staticFieldValues).length > 0) {
                          secondaryCardsItems.isCardDisable = false;
                        } else {
                          secondaryCardsItems.isCardDisable = true;
                        }

                        secondaryCardsItems.staticFieldValues = {
                          name:
                            Object.keys(secondaryCardsItems.staticFieldValues).length > 0
                              ? secondaryCardsItems.staticFieldValues.name
                              : null,
                          din:
                            Object.keys(secondaryCardsItems.staticFieldValues).length > 0
                              ? secondaryCardsItems.staticFieldValues.din
                              : null,
                          mobile:
                            Object.keys(secondaryCardsItems.staticFieldValues).length > 0
                              ? secondaryCardsItems.staticFieldValues.mobile
                              : null,
                          prevmobile:
                            Object.keys(secondaryCardsItems.staticFieldValues).length > 0
                              ? secondaryCardsItems.staticFieldValues.mobile
                              : null,
                          email:
                            Object.keys(secondaryCardsItems.staticFieldValues).length > 0
                              ? secondaryCardsItems.staticFieldValues.email
                              : null
                        };
                      }
                    }

                    if (item.masterCardModel.cardType.typeCode === 'DOCUMENT') {
                      secondaryCardsItems.isDataCapture = false;
                    }

                    secondaryCardsItems.selectedFields.forEach((fieldsItem, fieldsIndex) => {
                      if (item.masterCardModel.cardType.typeCode === 'DOCUMENT') {
                        fieldsItem.isOpen = false;
                        fieldsItem.isDocumentSubmit = true;
                        fieldsItem.isOpenPopUp = false;
                        fieldsItem.selectedFieldData = null;
                        fieldsItem.fileBack = null;
                        fieldsItem.kycInputBack = null;
                        fieldsItem.file = null;
                        fieldsItem.kycInput = null;
                        fieldsItem.kycPassProcted = 'No';
                        fieldsItem.isProvideLater = false;
                        fieldsItem.isUnableToSubmit = false;
                        fieldsItem.remarks = null;

                        if (fieldsItem?.storedField !== null) {
                          if (
                            fieldsItem?.storedField?.documentMap !== null &&
                            fieldsItem?.storedField?.documentMap !== '' &&
                            fieldsItem?.storedField?.documentMap !== undefined &&
                            Object.keys(fieldsItem?.storedField?.documentMap).length !== 0
                          ) {
                            responseData.data.journeyConfigs.journeyModel.journeyWizards[
                              wizardItemIndex
                            ].selectedCards[cardIndex].secondaryCards[
                              secondaryCardsIndex
                            ].selectedFields[fieldsIndex].isDocumentSubmit = false;
                            Object.values(fieldsItem?.storedField?.documentMap).map(
                              (docItem, docIndex) => (docItem.isDocumentSubmit = true)
                            );
                          }
                        }
                      } else {
                        fieldsItem.storedField.options =
                          item.selectedFields[fieldsIndex].storedField.options;
                      }

                      if (
                        fieldsItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldCode ===
                        'COUNTRY'
                      ) {
                        if (fieldsItem?.storedField !== null) {
                          fieldsItem.storedField.options = countryListRes.allCountry;
                        }
                      } else if (
                        fieldsItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldCode === 'STATE'
                      ) {
                        if (fieldsItem?.storedField !== null) {
                          if (fieldsItem?.storedField?.value !== null) {
                            const getStateId = fieldsItem?.storedField?.value;
                            countryListRes?.allState?.forEach((allStateItem) => {
                              if (allStateItem[getStateId.countryId] !== undefined) {
                                fieldsItem.storedField.options = allStateItem[getStateId.countryId];
                              }
                            });
                            setTimeout(() => {
                              countryListRes?.allState?.forEach((allStateItem) => {
                                if (allStateItem[getStateId.countryId] !== undefined) {
                                  fieldsItem.storedField.options =
                                    allStateItem[getStateId.countryId];
                                }
                              });
                            }, 1000);
                          }
                        }
                      } else if (
                        fieldsItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldCode === 'CITY'
                      ) {
                        if (fieldsItem?.storedField !== null) {
                          if (fieldsItem?.storedField?.value !== null) {
                            const getStateId = fieldsItem?.storedField?.value;
                            countryListRes.allCity.forEach((allStateItem) => {
                              if (allStateItem[getStateId.stateId] !== undefined) {
                                fieldsItem.storedField.options = allStateItem[getStateId.stateId];
                              }
                            });
                            setTimeout(() => {
                              countryListRes.allCity.forEach((allStateItem) => {
                                if (allStateItem[getStateId.stateId] !== undefined) {
                                  fieldsItem.storedField.options = allStateItem[getStateId.stateId];
                                }
                              });
                            }, 2000);
                          }
                        }
                      }
                    });
                  });
                }
              });
            } else if (wizardItem.reviewCards !== null && wizardItem.reviewCards !== undefined) {
              wizardItem.reviewCards.forEach((item, cardIndex) => {
                item.selectedJourneyReviewCards.forEach((item1, cardIndex1) => {
                  item1.reviewCardFields.forEach((item2, cardIndex2) => {
                    if (
                      item2?.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster?.fieldCode ===
                      'COUNTRY'
                    ) {
                      if (item2?.cardDetail?.storedField !== null) {
                        item2.cardDetail.storedField.options = countryListRes.allCountry;
                      }
                    } else if (
                      item2?.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster?.fieldCode ===
                      'STATE'
                    ) {
                      if (item2?.cardDetail?.storedField !== null) {
                        if (item2?.cardDetail?.storedField?.value !== null) {
                          const getStateId = item2?.cardDetail?.storedField?.value;
                          countryListRes?.allState?.forEach((allStateItem) => {
                            if (allStateItem[getStateId.countryId] !== undefined) {
                              item2.cardDetail.storedField.options =
                                allStateItem[getStateId.countryId];
                            }
                          });
                          setTimeout(() => {
                            countryListRes?.allState?.forEach((allStateItem) => {
                              if (allStateItem[getStateId.countryId] !== undefined) {
                                item2.cardDetail.storedField.options =
                                  allStateItem[getStateId.countryId];
                              }
                            });
                          }, 1000);
                        }
                      }
                    } else if (
                      item2?.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster?.fieldCode ===
                      'CITY'
                    ) {
                      if (item2?.cardDetail?.storedField !== null) {
                        if (item2?.cardDetail?.storedField?.value !== null) {
                          const getStateId = item2?.cardDetail?.storedField?.value;
                          countryListRes.allCity.forEach((allStateItem) => {
                            if (allStateItem[getStateId.stateId] !== undefined) {
                              item2.cardDetail.storedField.options =
                                allStateItem[getStateId.stateId];
                            }
                          });
                          setTimeout(() => {
                            countryListRes.allCity.forEach((allStateItem) => {
                              if (allStateItem[getStateId.stateId] !== undefined) {
                                item2.cardDetail.storedField.options =
                                  allStateItem[getStateId.stateId];
                              }
                            });
                          }, 2000);
                        }
                      }
                    }
                  });
                });
              });
            }
          });
          // new code for document url code
          if (
            window.location.href.split('&')[window.location.href.split('&').length - 1] !== null
          ) {
            if (
              window.location.href.split('&')[window.location.href.split('&').length - 1] ===
              'review'
            ) {
              const reviewArray = journeyReviewCombineData.filter(
                (item) => item.wizardCode === 'REVIEW'
              );
              setJourneyData(reviewArray);
            } else if (
              window.location.href.split('&')[window.location.href.split('&').length - 1] ===
              'document'
            ) {
              const documentArray = journeyReviewCombineData.filter(
                (item) => item.wizardCode !== 'REVIEW'
              );
              const documentArrayNew = documentArray?.filter(
                (wizItem) =>
                  wizItem?.selectedCards[0].masterCardModel.cardType.typeCode === 'DOCUMENT'
              );
              setJourneyData(documentArrayNew);
            } else {
              setJourneyData(journeyReviewCombineData);
            }
          }
        }
      } else if (type === 'saveWizard') {
        setActiveStep(responseData.data.savedWizardData.activeWizardNumber);
        localStorage.setItem(
          'savedApplicationId',
          responseData.data.savedWizardData.recommendationId
        );
        loantyprapiFire(
          'journeyOffline',
          Number(responseData.data.savedWizardData.recommendationId),
          '',
          '',
          ''
        );
      } else if (type === 'uploadDocument') {
        const savedApplicationId = localStorage.getItem(`savedApplicationId`);
        if (savedApplicationId === null) {
          localStorage.setItem(
            'savedApplicationId',
            responseData.data.uploadDocumentResponseModel.recommendationId
          );
        }

        loantyprapiFire(
          'journeyOffline',
          Number(responseData.data.uploadDocumentResponseModel.recommendationId),
          '',
          '',
          ''
        );
      } else if (type === 'deleteDocument') {
        const savedApplicationId = localStorage.getItem(`savedApplicationId`);
        loantyprapiFire(
          'journeyOffline',
          savedApplicationId !== null
            ? Number(savedApplicationId)
            : aptokenx !== null
            ? Number(aptokenx)
            : null,
          '',
          '',
          ''
        );
      } else if (type === 'finish') {
        setLoaderMsg('Your Application is Successfully Submitted');
        setLoaderBox(true);
      } else if (type === 'reviewEditUpdate') {
        setReviewItemData(null);
        setDocPrevFlag({
          flag: false,
          srcPath: null,
          imgaltTag: null,
          contentType: null,
          reviewInd: null
        });
        setHelperTextMsg({ status: false, index: null });

        const savedApplicationId = localStorage.getItem(`savedApplicationId`);

        loantyprapiFire(
          'journeyOffline',
          Number(
            savedApplicationId !== null
              ? Number(savedApplicationId)
              : aptokenx !== null
              ? Number(aptokenx)
              : null
          ),
          '',
          '',
          ''
        );
      }
    } else if (responseData.status === 'error') {
      // setLoaderBoxNew(false);
      setLoaderBoxNew(false);
      if (type === 'journeyOffline') {
        let errorMsg = '';
        if (
          responseData.description !== null &&
          responseData.description.includes('Unable to find published journey')
        ) {
          errorMsg = 'Unable to find published journey - Cannot proceed';
        } else {
          errorMsg = 'Unable to get details for selected loan and employment type';
        }
        setLoaderMsg(errorMsg);
      } else if (type === 'saveWizard') {
        setLoaderMsg('Unable to save loan application data');
      } else if (type === 'uploadDocument') {
        setLoaderMsg('Unable to upload document for the loan application');
      } else if (type === 'reviewEditUpdate') {
        setLoaderMsg('Something went wrong');
      }
    } else {
      setLoaderBoxNew(false);
      // setLoaderMsg('Something went wrong');
      setOpenApiError(true);
      setErrorMessage('Something went wrong !');
    }
  };

  const handleClose = (x, y, z, secondaryCardsItemIndex) => {
    const prevData = journeyData;
    if (secondaryCardsItemIndex !== '' && y !== '') {
      prevData[x].selectedCards[y].secondaryCards[secondaryCardsItemIndex].selectedFields[
        z
      ].isOpen = false;
      prevData[x].selectedCards[y].secondaryCards[secondaryCardsItemIndex].selectedFields[
        z
      ].isOpenPopUp = false;
      prevData[x].selectedCards[y].secondaryCards[secondaryCardsItemIndex].selectedFields[
        z
      ].fileBack = null;
      prevData[x].selectedCards[y].secondaryCards[secondaryCardsItemIndex].selectedFields[
        z
      ].kycInputBack = null;
      prevData[x].selectedCards[y].secondaryCards[secondaryCardsItemIndex].selectedFields[z].file =
        null;
      prevData[x].selectedCards[y].secondaryCards[secondaryCardsItemIndex].selectedFields[
        z
      ].kycInput = null;
      prevData[x].selectedCards[y].secondaryCards[secondaryCardsItemIndex].selectedFields[
        z
      ].kycPassProcted = 'No';
      prevData[x].selectedCards[y].secondaryCards[secondaryCardsItemIndex].selectedFields[
        z
      ].isProvideLater = false;
      prevData[x].selectedCards[y].secondaryCards[secondaryCardsItemIndex].selectedFields[
        z
      ].isUnableToSubmit = false;
      prevData[x].selectedCards[y].secondaryCards[secondaryCardsItemIndex].selectedFields[
        z
      ].remarks = null;
    } else if (secondaryCardsItemIndex === '' && y !== '') {
      prevData[x].selectedCards[y].selectedFields[z].isOpen = false;
      prevData[x].selectedCards[y].selectedFields[z].isOpenPopUp = false;
      prevData[x].selectedCards[y].selectedFields[z].fileBack = null;
      prevData[x].selectedCards[y].selectedFields[z].kycInputBack = null;
      prevData[x].selectedCards[y].selectedFields[z].file = null;
      prevData[x].selectedCards[y].selectedFields[z].kycInput = null;
      prevData[x].selectedCards[y].selectedFields[z].kycPassProcted = 'No';
      prevData[x].selectedCards[y].selectedFields[z].isProvideLater = false;
      prevData[x].selectedCards[y].selectedFields[z].isUnableToSubmit = false;
      prevData[x].selectedCards[y].selectedFields[z].remarks = null;
    }

    setJourneyData([...prevData]);
  };

  const finishJourney = (type) => {
    const savedApplicationId = localStorage.getItem(`savedApplicationId`);
    if (type === 'finish') {
      loantyprapiFire('finish', null, '', '', '');
    } else if (type === 'onlyNext') {
      setActiveStep((activeStep) => activeStep + 1);
      if (
        journeyData[activeStep]?.selectedCards[0]?.masterCardModel?.cardType?.typeCode !==
        'DOCUMENT'
      ) {
        loantyprapiFire('saveWizard', '', '', '', '');
      } else {
        loantyprapiFire('journeyOffline', savedApplicationId, '', '', '');
      }
    } else {
      setActiveStep((activeStep) => activeStep - 1);
      if (savedApplicationId !== null) {
        loantyprapiFire('journeyOffline', savedApplicationId, '', '', '');
      }
    }
  };

  return (
    <Container maxWidth="lg">
      <Box pt={3} pb={3}>
        {journeyData && (
          <Box>
            <Stepper
              connector=""
              activeStep={activeStep}
              sx={{ marginBottom: '25px' }}
              className="stepWizardOuter"
            >
              {journeyData?.map((wizItem, wizItemIndex) => (
                <Step className="stepWizard">
                  <StepLabel className="stepWizardLabel">{wizItem?.wizardName}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <PreviewComponent
              journeyData={journeyData}
              setJourneyData={setJourneyData}
              loantyprapiFire={loantyprapiFire}
              handleClose={handleClose}
              activeStep={activeStep}
              finishJourney={finishJourney}
              countryListRes={countryListRes}
              docPrevFlag={docPrevFlag}
              setDocPrevFlag={setDocPrevFlag}
              reviewItemData={reviewItemData}
              setReviewItemData={setReviewItemData}
              helperTextMsg={helperTextMsg}
              setHelperTextMsg={setHelperTextMsg}
            />
          </Box>
        )}
      </Box>
      <Dialog open={loaderBox}>
        <Box
          display="flex"
          width={400}
          height={200}
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          p={4}
        >
          <Typography textAlign="left" mt={3}>
            {loaderMsg}
          </Typography>
          <Box paddingTop="1.5rem">
            <Button
              onClick={() => {
                window.location.href = `${domainUrl}recommendation`;
              }}
              className="mainBtn"
              style={{ minWidth: 'auto', cursor: 'pointer' }}
              variant="contained"
            >
              Ok
            </Button>
          </Box>
        </Box>
      </Dialog>

      <Dialog open={loaderBoxNew}>
        <Box
          display="flex"
          width={400}
          height={200}
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          p={8}
        >
          <CircularProgress />
          <Typography textAlign="center" mt={3}>
            {loaderMsg}
          </Typography>
        </Box>
      </Dialog>
      <ApiErrorMessage
        openApiError={openApiError}
        setOpenApiError={setOpenApiError}
        errorMessage={errorMessage}
      />
    </Container>
  );
}

function PreviewComponent({
  journeyData,
  setJourneyData,
  loantyprapiFire,
  handleClose,
  activeStep,
  finishJourney,
  countryListRes,
  docPrevFlag,
  setDocPrevFlag,
  reviewItemData,
  setReviewItemData,
  helperTextMsg,
  setHelperTextMsg
}) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const docPrevHandler = (type, srcData, index) => {
    if (type === 'open') {
      const responseData = JSON.parse(srcData);

      setDocPrevFlag({
        flag: true,
        srcPath: responseData.src,
        imgaltTag: responseData.alt,
        contentType: responseData.contentType,
        reviewInd: index
      });
    } else {
      setReviewItemData(null);
      setDocPrevFlag({
        flag: false,
        srcPath: null,
        imgaltTag: null,
        contentType: null,
        reviewInd: index
      });
    }
  };

  let isHeaderRendered = false;
  const padTop = '0px';
  const borderBottomo = '0px';
  let documentBox = 0;

  const uploadKycBackFile = (idd) => {
    const browseField = document.getElementById(idd);
    browseField.click();
  };

  const uploadKycFile = (idd) => {
    const browseField = document.getElementById(idd);
    browseField.click();
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  const stateCityAction = (
    id,
    wizItemIndex,
    code,
    arrayData,
    secondaryCardsItemIndex,
    reviewDataArr
  ) => {
    const prevData = journeyData;
    if (secondaryCardsItemIndex !== '') {
      prevData[activeStep]?.selectedCards[wizItemIndex]?.secondaryCards[
        secondaryCardsItemIndex
      ]?.selectedFields.forEach((selectedField) => {
        if (selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldCode === code) {
          if (selectedField.storedField !== null) {
            arrayData.forEach((rowItem) => {
              if (rowItem[id] !== undefined) {
                selectedField.storedField.options = rowItem[id];
              }
            });
          }
        }
      });
    } else if (prevData[activeStep].wizardCode === 'REVIEW') {
      const prevDataNew = docPrevFlag.imgaltTag;
      reviewDataArr.forEach((selectedField) => {
        if (
          selectedField?.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster?.fieldCode === code
        ) {
          if (selectedField?.cardDetail?.storedField !== null) {
            arrayData.forEach((rowItem) => {
              if (rowItem[id] !== undefined) {
                selectedField.cardDetail.storedField.options = rowItem[id];
              }
            });
          }
        }
      });
    } else {
      prevData[activeStep]?.selectedCards[wizItemIndex]?.selectedFields?.forEach(
        (selectedField) => {
          if (selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldCode === code) {
            if (selectedField.storedField !== null) {
              arrayData.forEach((rowItem) => {
                if (rowItem[id] !== undefined) {
                  selectedField.storedField.options = rowItem[id];
                }
              });
            }
          }
        }
      );
    }

    setJourneyData([...prevData]);
  };

  return (
    <>
      {journeyData[activeStep]?.wizardCode !== 'REVIEW' ? (
        journeyData[activeStep]?.selectedCards.map((wizItem, wizItemIndex) => (
          <Grid item xs="12" sm="6" md="6" mt={8}>
            <Box className="viewLeadCard" mb={5} style={{ position: 'relative' }}>
              <Typography variant="body1" className="headingLineUp" style={{ top: '-31px' }}>
                {wizItem?.cardCurrentTitle !== null && wizItem?.cardCurrentTitle.trim() !== ''
                  ? wizItem?.cardCurrentTitle
                  : wizItem?.masterCardModel?.cardName}{' '}
                {wizItem?.secondaryCards?.length > 0 ? '1' : ''}
              </Typography>

              {wizItem.enableSubCard === true ? (
                <Tooltip title="Add" placement="top" arrow>
                  <IconButton
                    style={{
                      position: 'absolute',
                      top: '-13px',
                      right: '15px'
                    }}
                    onClick={(e) => {
                      const prevData = journeyData;
                      let prevDataObj = {};
                      prevDataObj.uniqueIdentifierInformation = null;
                      if (
                        wizItem.masterCardModel.cardType.typeCode === 'DOCUMENT' &&
                        (wizItem?.cardPurpose?.cardPurposeCode === 'DIRECTOR' ||
                          wizItem?.cardPurpose?.cardPurposeCode === 'PARTNER' ||
                          wizItem?.cardPurpose?.cardPurposeCode === 'PROMOTER')
                      ) {
                        prevDataObj.isCardDisable = true;
                        prevDataObj.staticFieldValues = {
                          name: null,
                          din: null,
                          mobile: null,
                          prevmobile: null,
                          email: null
                        };
                      }

                      if (wizItem.masterCardModel.cardType.typeCode === 'DOCUMENT') {
                        prevDataObj.isDataCapture = false;
                      }

                      prevDataObj.selectedFields =
                        prevData[activeStep].selectedCards[wizItemIndex].selectedFields;

                      prevDataObj = JSON.parse(JSON.stringify(prevDataObj));

                      prevDataObj.selectedFields.forEach((item, index) => {
                        item.storedField.documentMap = null;
                        item.storedField.editedOcrDetails = null;
                        item.storedField.isSingleFaceDocument = null;
                        item.storedField.ocrDetails = null;
                        item.storedField.ocrValue = null;
                        item.isDocumentSubmit = true;
                        item.storedField.value = null;
                      });
                      prevData[activeStep].selectedCards[wizItemIndex].secondaryCards.push(
                        prevDataObj
                      );
                      setJourneyData([...prevData]);
                    }}
                    className={
                      wizItem.subCardLimit <
                      journeyData[activeStep].selectedCards[wizItemIndex].secondaryCards.length + 1
                        ? 'display_none'
                        : 'squareIconButton'
                    }
                    sx={{ marginBottom: '4px' }}
                  >
                    <MdOutlineAdd size={18} />
                  </IconButton>
                </Tooltip>
              ) : (
                ''
              )}
              <Grid container spacing={3} style={{ marginLeft: '-12px' }}>
                {wizItem?.selectedFields.map((selectedField, selectedFieldIndex) => {
                  if (
                    selectedField?.storedField?.documentMap !== null &&
                    selectedField?.storedField !== null &&
                    selectedField?.storedField?.documentMap !== '' &&
                    selectedField?.storedField?.documentMap !== undefined &&
                    Object.keys(selectedField?.storedField?.documentMap).length !== 0
                  ) {
                    documentBox += 1;
                  }

                  if (selectedFieldIndex >= 1) {
                    isHeaderRendered = true;
                  } else {
                    isHeaderRendered = false;
                  }

                  return wizItem.masterCardModel.cardType.typeCode === 'DOCUMENT' ? (
                    <Grid
                      item
                      xs={12}
                      style={{
                        paddingTop: padTop,
                        paddingLeft: '10px',
                        paddingRight: '10px'
                      }}
                    >
                      <Box className={`${isHeaderRendered ? 'notfirstElement' : ''}`}>
                        {!isHeaderRendered && (
                          <>
                            {/* ------ new code -------- */}
                            {wizItem?.cardPurpose?.cardPurposeCode === 'PROMOTER' ||
                            wizItem?.cardPurpose?.cardPurposeCode === 'DIRECTOR' ||
                            wizItem?.cardPurpose?.cardPurposeCode === 'PARTNER' ? (
                              <Grid container spacing={2} alignItems="flex-end" mt={1}>
                                <Grid item xs>
                                  <FormControl fullWidth className="formGroup">
                                    <Typography variant="body1" className="FormLabel">
                                      Name
                                    </Typography>
                                    <TextField
                                      inputProps={{ className: 'formControl' }}
                                      fullWidth
                                      placeholder="Name"
                                      value={
                                        journeyData[activeStep]?.selectedCards[wizItemIndex]
                                          ?.staticFieldValues?.name
                                      }
                                      onChange={(e) => {
                                        const prevData = journeyData;
                                        prevData[activeStep].selectedCards[
                                          wizItemIndex
                                        ].staticFieldValues.name = e.target.value;
                                        setJourneyData([...prevData]);
                                      }}
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item xs>
                                  <FormControl fullWidth className="formGroup">
                                    <Typography variant="body1" className="FormLabel">
                                      Mobile
                                    </Typography>
                                    <TextField
                                      inputProps={{ className: 'formControl' }}
                                      fullWidth
                                      placeholder="Mobile"
                                      value={
                                        journeyData[activeStep]?.selectedCards[wizItemIndex]
                                          ?.staticFieldValues?.mobile
                                      }
                                      onChange={(e) => {
                                        const prevData = journeyData;
                                        prevData[activeStep].selectedCards[
                                          wizItemIndex
                                        ].staticFieldValues.mobile = e.target.value;
                                        setJourneyData([...prevData]);
                                      }}
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item xs>
                                  <FormControl fullWidth className="formGroup">
                                    <Typography variant="body1" className="FormLabel">
                                      Email
                                    </Typography>
                                    <TextField
                                      inputProps={{ className: 'formControl' }}
                                      fullWidth
                                      placeholder="Email"
                                      value={
                                        journeyData[activeStep]?.selectedCards[wizItemIndex]
                                          ?.staticFieldValues?.email
                                      }
                                      onChange={(e) => {
                                        const prevData = journeyData;
                                        prevData[activeStep].selectedCards[
                                          wizItemIndex
                                        ].staticFieldValues.email = e.target.value;
                                        setJourneyData([...prevData]);
                                      }}
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item xs="auto">
                                  <Box>
                                    <Button
                                      style={{ padding: '9px 20px' }}
                                      className="mainBtn mainBtnSmall"
                                      onClick={(e) => {
                                        let allowToFireApi = true;
                                        let validateFld = true;
                                        let parentvalidateFld = true;
                                        journeyData[activeStep].selectedCards.every(
                                          (selectedCardsItem) => {
                                            if (
                                              selectedCardsItem.staticFieldValues.name === null ||
                                              selectedCardsItem.staticFieldValues.name === ''
                                            ) {
                                              const imgDetailsObj = {};
                                              imgDetailsObj.src = '';
                                              imgDetailsObj.alt = 'Enter Name';
                                              imgDetailsObj.contentType = 'mobilenoValidation';
                                              docPrevHandler(
                                                'open',
                                                JSON.stringify(imgDetailsObj),
                                                null
                                              );

                                              parentvalidateFld = false;
                                            } else if (
                                              selectedCardsItem.staticFieldValues.mobile === null ||
                                              selectedCardsItem.staticFieldValues.mobile === ''
                                            ) {
                                              const imgDetailsObj = {};
                                              imgDetailsObj.src = '';
                                              imgDetailsObj.alt = 'Enter Mobile No';
                                              imgDetailsObj.contentType = 'mobilenoValidation';
                                              docPrevHandler(
                                                'open',
                                                JSON.stringify(imgDetailsObj),
                                                null
                                              );
                                              parentvalidateFld = false;
                                            } else if (
                                              selectedCardsItem.staticFieldValues.email === null ||
                                              selectedCardsItem.staticFieldValues.email === ''
                                            ) {
                                              const imgDetailsObj = {};
                                              imgDetailsObj.src = '';
                                              imgDetailsObj.alt = 'Enter Email Id';
                                              imgDetailsObj.contentType = 'mobilenoValidation';
                                              docPrevHandler(
                                                'open',
                                                JSON.stringify(imgDetailsObj),
                                                null
                                              );
                                              parentvalidateFld = false;
                                            }

                                            if (
                                              parentvalidateFld === true &&
                                              selectedCardsItem.secondaryCards.length > 0
                                            ) {
                                              selectedCardsItem.secondaryCards.forEach(
                                                (selItem) => {
                                                  console.log(
                                                    'secondaryCardsItesecondaryCardsItem',
                                                    selItem.staticFieldValues
                                                  );
                                                  if (
                                                    selItem.staticFieldValues.name === null ||
                                                    selItem.staticFieldValues.name === ''
                                                  ) {
                                                    const imgDetailsObj = {};
                                                    imgDetailsObj.src = '';
                                                    imgDetailsObj.alt = 'Enter Name';
                                                    imgDetailsObj.contentType =
                                                      'mobilenoValidation';
                                                    docPrevHandler(
                                                      'open',
                                                      JSON.stringify(imgDetailsObj),
                                                      null
                                                    );

                                                    validateFld = false;
                                                  } else if (
                                                    selItem.staticFieldValues.mobile === null ||
                                                    selItem.staticFieldValues.mobile === ''
                                                  ) {
                                                    const imgDetailsObj = {};
                                                    imgDetailsObj.src = '';
                                                    imgDetailsObj.alt = 'Enter Mobile No';
                                                    imgDetailsObj.contentType =
                                                      'mobilenoValidation';
                                                    docPrevHandler(
                                                      'open',
                                                      JSON.stringify(imgDetailsObj),
                                                      null
                                                    );
                                                    validateFld = false;
                                                  } else if (
                                                    selItem.staticFieldValues.email === null ||
                                                    selItem.staticFieldValues.email === ''
                                                  ) {
                                                    const imgDetailsObj = {};
                                                    imgDetailsObj.src = '';
                                                    imgDetailsObj.alt = 'Enter Email Id';
                                                    imgDetailsObj.contentType =
                                                      'mobilenoValidation';
                                                    docPrevHandler(
                                                      'open',
                                                      JSON.stringify(imgDetailsObj),
                                                      null
                                                    );
                                                    validateFld = false;
                                                  }
                                                }
                                              );

                                              if (validateFld === true) {
                                                let cardSeqValidate =
                                                  selectedCardsItem.secondaryCards.map((itemnext) =>
                                                    Object.keys(itemnext.staticFieldValues).length >
                                                    0
                                                      ? itemnext.staticFieldValues.mobile
                                                      : ''
                                                  );

                                                cardSeqValidate = [
                                                  ...cardSeqValidate,
                                                  selectedCardsItem.staticFieldValues.mobile
                                                ];

                                                const isDuplicatecardCurrentSeqValidate =
                                                  cardSeqValidate.some(
                                                    (item, idx) =>
                                                      cardSeqValidate.indexOf(item) !== idx
                                                  );

                                                if (isDuplicatecardCurrentSeqValidate === true) {
                                                  const imgDetailsObj = {};
                                                  imgDetailsObj.src = '';
                                                  imgDetailsObj.alt =
                                                    'Mobile no should be unique for each director document';
                                                  imgDetailsObj.contentType = 'mobilenoValidation';
                                                  docPrevHandler(
                                                    'open',
                                                    JSON.stringify(imgDetailsObj),
                                                    null
                                                  );

                                                  allowToFireApi = false;
                                                }
                                              }
                                            }
                                            return allowToFireApi;
                                          }
                                        );

                                        if (
                                          allowToFireApi === true &&
                                          validateFld === true &&
                                          parentvalidateFld === true
                                        ) {
                                          loantyprapiFire(
                                            'uploadDocument',
                                            activeStep,
                                            wizItemIndex,
                                            '',
                                            ''
                                          );
                                        }
                                      }}
                                    >
                                      Save
                                    </Button>
                                  </Box>
                                </Grid>
                              </Grid>
                            ) : (
                              ''
                            )}
                            {/* ------ new code -------- */}
                            <Typography
                              variant="body2"
                              marginBottom={2}
                              marginTop={2}
                              className={
                                wizItem.isCardDisable ? 'disabledDocument' : 'enabledDocument'
                              }
                            >
                              For faster processing of your application form, please scan and upload
                              a pdf/jpg file for the documents mentioned below.
                            </Typography>
                          </>
                        )}
                        <Box>
                          <TableContainer
                            component={Paper}
                            sx={{ borderRadius: '0.5rem 0.5rem 0 0', marginBottom: '0' }}
                          >
                            <Table
                              aria-label="customized table"
                              size="small"
                              padding="normal" /* ------ new code -------- */
                              className={
                                wizItem.isCardDisable ? 'disabledDocument' : 'enabledDocument'
                              }
                              /* ------ new code -------- */
                            >
                              {!isHeaderRendered && (
                                <TableHead className="tableHead">
                                  <TableRow>
                                    <TableCell
                                      style={{ width: '30%', borderBottom: borderBottomo }}
                                    >
                                      Applicant Documents
                                    </TableCell>
                                    <TableCell
                                      style={{ width: '15%', borderBottom: borderBottomo }}
                                    >
                                      Action
                                    </TableCell>
                                    <TableCell
                                      style={{ width: '15%', borderBottom: borderBottomo }}
                                    >
                                      Will Provide Later
                                    </TableCell>
                                    <TableCell
                                      style={{ width: '15%', borderBottom: borderBottomo }}
                                    >
                                      Unable to Submit
                                    </TableCell>
                                    <TableCell
                                      style={{ width: '20%', borderBottom: borderBottomo }}
                                    >
                                      Remarks
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                              )}

                              <TableBody>
                                {selectedField.isDocumentSubmit ? (
                                  <TableRow
                                    key={selectedFieldIndex}
                                    className={`${isHeaderRendered ? '' : 'firstElement'}`}
                                  >
                                    <TableCell
                                      style={{ width: '30%', borderBottom: borderBottomo }}
                                    >
                                      {
                                        selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                          ?.fieldName
                                      }
                                      {selectedField?.fieldCurrentIsMendatory !== null ? (
                                        selectedField?.fieldCurrentIsMendatory ? (
                                          <Typography variant="span" color="error">
                                            *
                                          </Typography>
                                        ) : selectedField.cardFieldMapping
                                            .fieldDefaultIsMendatory !== null ? (
                                          selectedField.cardFieldMapping.fieldDefaultIsMendatory ? (
                                            <Typography variant="span" color="error">
                                              *
                                            </Typography>
                                          ) : (
                                            ''
                                          )
                                        ) : (
                                          ''
                                        )
                                      ) : (
                                        ''
                                      )}
                                    </TableCell>
                                    <TableCell
                                      style={{ width: '15%', borderBottom: borderBottomo }}
                                    >
                                      <IconButton
                                        aria-label="Example"
                                        className="docIcon"
                                        onClick={(e) => {
                                          const prevData = journeyData;
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].selectedFields[selectedFieldIndex].isOpen = true;
                                          setJourneyData([...prevData]);
                                        }}
                                      >
                                        <MdUploadFile />
                                      </IconButton>
                                    </TableCell>
                                    <TableCell
                                      style={{ width: '15%', borderBottom: borderBottomo }}
                                    >
                                      <Checkbox
                                        size="small"
                                        checked={
                                          journeyData[activeStep].selectedCards[wizItemIndex]
                                            .selectedFields[selectedFieldIndex].isProvideLater
                                        }
                                        disabled={
                                          journeyData[activeStep].selectedCards[wizItemIndex]
                                            .selectedFields[selectedFieldIndex].isUnableToSubmit
                                        }
                                        onChange={(e) => {
                                          const prevData = journeyData;
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].selectedFields[selectedFieldIndex].isProvideLater =
                                            e.target.checked;
                                          setJourneyData([...prevData]);
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell
                                      style={{ width: '15%', borderBottom: borderBottomo }}
                                    >
                                      <Checkbox
                                        size="small"
                                        checked={
                                          journeyData[activeStep].selectedCards[wizItemIndex]
                                            .selectedFields[selectedFieldIndex].isUnableToSubmit
                                        }
                                        disabled={
                                          journeyData[activeStep].selectedCards[wizItemIndex]
                                            .selectedFields[selectedFieldIndex].isProvideLater
                                        }
                                        onChange={(e) => {
                                          const prevData = journeyData;
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].selectedFields[selectedFieldIndex].isUnableToSubmit =
                                            e.target.checked;
                                          setJourneyData([...prevData]);
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell
                                      style={{ width: '20%', borderBottom: borderBottomo }}
                                    >
                                      <TextField
                                        fullWidth
                                        size="small"
                                        inputProps={{ className: 'formControl formControlRemark' }}
                                        placeholder="Remarks"
                                        value={
                                          journeyData[activeStep].selectedCards[wizItemIndex]
                                            .selectedFields[selectedFieldIndex].remarks
                                        }
                                        onChange={(e) => {
                                          const prevData = journeyData;
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].selectedFields[selectedFieldIndex].remarks =
                                            e.target.value;
                                          setJourneyData([...prevData]);
                                        }}
                                      />
                                    </TableCell>
                                  </TableRow>
                                ) : (
                                  ''
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>
                      </Box>
                      <Dialog
                        className="PopupBox"
                        open={
                          journeyData[activeStep].selectedCards[wizItemIndex].selectedFields[
                            selectedFieldIndex
                          ].isOpen
                        }
                        onClose={() =>
                          handleClose(activeStep, wizItemIndex, selectedFieldIndex, '')
                        }
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                      >
                        <DialogTitle id="alert-dialog-title" className="popupHeadingg">
                          <Typography variant="h6" className="popupTitlee">
                            Upload Document
                          </Typography>
                          <IconButton
                            onClick={() =>
                              handleClose(activeStep, wizItemIndex, selectedFieldIndex, '')
                            }
                            size="small"
                          >
                            <CloseIcon />
                          </IconButton>
                        </DialogTitle>

                        <DialogContent dividers className="PopupContent">
                          <DialogContentText id="alert-dialog-description">
                            <FormControl sx={{ width: '100%' }}>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue="Local File"
                                name="radio-buttons-group"
                              >
                                <Box container className="uploadPopupRow">
                                  <Box className="uploadPopupInnerRow">
                                    <FormControlLabel
                                      value="Local File"
                                      control={<Radio size="small" />}
                                      label=""
                                      sx={{ marginRight: '0.5rem' }}
                                    />
                                    <Typography variant="caption" className="UploadPopupIcon">
                                      <MdUpload className="UploadIcon" />
                                    </Typography>
                                    <Typography
                                      variant="body1"
                                      marginRight={1}
                                      className="FileTypeName"
                                    >
                                      Local Files
                                    </Typography>
                                    <input
                                      id="kycUploader"
                                      className="Fileupload hideForView"
                                      onChange={(e) => {
                                        const filename = e.target.files[0];
                                        const prevData = journeyData;
                                        if (filename.size > 0) {
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].selectedFields[selectedFieldIndex].file = filename;
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].selectedFields[selectedFieldIndex].kycInput =
                                            filename.name;
                                        } else {
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].selectedFields[selectedFieldIndex].file = null;
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].selectedFields[selectedFieldIndex].kycInput = '';
                                          const imgDetailsObj = {};
                                          imgDetailsObj.src = '';
                                          imgDetailsObj.alt = 'File size must be greater then 0 kb';
                                          imgDetailsObj.contentType = 'content';
                                          docPrevHandler(
                                            'open',
                                            JSON.stringify(imgDetailsObj),
                                            null
                                          );
                                        }
                                        setJourneyData([...prevData]);
                                      }}
                                      type="file"
                                    />
                                    <ShowInputBox
                                      val={
                                        journeyData[activeStep].selectedCards[wizItemIndex]
                                          .selectedFields[selectedFieldIndex].kycInput
                                      }
                                    />
                                    <Button
                                      type="button"
                                      onClick={() => {
                                        uploadKycFile('kycUploader');
                                      }}
                                      className="uploadBtn"
                                    >
                                      Browse
                                    </Button>
                                  </Box>

                                  {selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldCode === 'AADHAR_CARD' ? (
                                    <Box className="uploadPopupInnerRow">
                                      <FormControlLabel
                                        value="Local File"
                                        control={<Radio size="small" />}
                                        label=""
                                        sx={{ marginRight: '0.5rem' }}
                                      />
                                      <Typography variant="caption" className="UploadPopupIcon">
                                        <MdUpload className="UploadIcon" />
                                      </Typography>
                                      <Typography
                                        variant="body1"
                                        marginRight={1}
                                        className="FileTypeName"
                                      >
                                        Local Files
                                      </Typography>
                                      <input
                                        id="kycBackUploader"
                                        className="Fileupload hideForView"
                                        onChange={(e) => {
                                          const filename = e.target.files[0];
                                          const prevData = journeyData;
                                          if (filename.size > 0) {
                                            prevData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].selectedFields[selectedFieldIndex].fileBack =
                                              filename;
                                            prevData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].selectedFields[selectedFieldIndex].kycInputBack =
                                              filename.name;
                                          } else {
                                            prevData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].selectedFields[selectedFieldIndex].fileBack = null;
                                            prevData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].selectedFields[selectedFieldIndex].kycInputBack = '';
                                            const imgDetailsObj = {};
                                            imgDetailsObj.src = '';
                                            imgDetailsObj.alt =
                                              'File size must be greater then 0 kb';
                                            imgDetailsObj.contentType = 'content';
                                            docPrevHandler(
                                              'open',
                                              JSON.stringify(imgDetailsObj),
                                              null
                                            );
                                          }
                                          setJourneyData([...prevData]);
                                        }}
                                        type="file"
                                      />
                                      <TextField
                                        value={
                                          journeyData[activeStep].selectedCards[wizItemIndex]
                                            .selectedFields[selectedFieldIndex].kycInputBack
                                        }
                                        inputProps={{ className: 'TextField', readOnly: true }}
                                        className="TextFieldGroup"
                                      />
                                      <Button
                                        type="button"
                                        onClick={() => {
                                          uploadKycBackFile('kycBackUploader');
                                        }}
                                        className="uploadBtn"
                                      >
                                        Browse
                                      </Button>
                                    </Box>
                                  ) : (
                                    ''
                                  )}

                                  <FormControl className="PassProtectB" defaultValue="No">
                                    <FormLabel
                                      id="demo-row-radio-buttons-group-label"
                                      sx={{ marginRight: '0.5rem' }}
                                    >
                                      Is your file password protected?
                                    </FormLabel>
                                    <RadioGroup
                                      row
                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                      name="row-radio-buttons-group"
                                      value={
                                        journeyData[activeStep].selectedCards[wizItemIndex]
                                          .selectedFields[selectedFieldIndex].kycPassProcted
                                      }
                                      onChange={(e) => {
                                        const prevData = journeyData;
                                        prevData[activeStep].selectedCards[
                                          wizItemIndex
                                        ].selectedFields[selectedFieldIndex].kycPassProcted =
                                          e.target.value;

                                        setJourneyData([...prevData]);
                                      }}
                                    >
                                      <FormControlLabel
                                        value="Yes"
                                        control={<Radio size="small" />}
                                        label="Yes"
                                      />
                                      <FormControlLabel
                                        value="No"
                                        control={<Radio size="small" />}
                                        label="No"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                  {journeyData[activeStep]?.selectedCards[wizItemIndex]
                                    ?.selectedFields[selectedFieldIndex]?.kycPassProcted ===
                                    'Yes' && (
                                    <TextField
                                      className="TextFieldGroup"
                                      inputProps={{ className: 'TextField' }}
                                      fullWidth="true"
                                    />
                                  )}
                                </Box>
                                <Box container className="uploadPopupRow">
                                  <Box className="uploadPopupInnerRow">
                                    <FormControlLabel
                                      value="Google Drive"
                                      control={<Radio size="small" />}
                                      label=""
                                      sx={{ marginRight: '0.5rem' }}
                                    />
                                    <Typography variant="caption" className="UploadPopupIcon">
                                      <img
                                        src="../static/icons/googleDrive.svg"
                                        alt="Google Drive"
                                      />
                                    </Typography>
                                    <Typography variant="body1" className="FileTypeName">
                                      Google Drive
                                    </Typography>
                                  </Box>
                                </Box>
                                <Box container className="uploadPopupRow">
                                  <Box className="uploadPopupInnerRow">
                                    <FormControlLabel
                                      value="Dropbox"
                                      control={<Radio size="small" />}
                                      label=""
                                      sx={{ marginRight: '0.5rem' }}
                                    />
                                    <Typography variant="caption" className="UploadPopupIcon">
                                      <img src="../static/icons/dropBox.svg" alt="Drop Box" />
                                    </Typography>
                                    <Typography variant="body1" className="FileTypeName">
                                      Dropbox
                                    </Typography>
                                  </Box>
                                </Box>
                                <Box container className="uploadPopupRow">
                                  <Box className="uploadPopupInnerRow">
                                    <FormControlLabel
                                      value="Digiloker"
                                      control={<Radio size="small" />}
                                      label=""
                                      sx={{ marginRight: '0.5rem' }}
                                    />
                                    <Typography variant="caption" className="UploadPopupIcon">
                                      <img src="../static/icons/digilocker.svg" alt="Digi Locker" />
                                    </Typography>
                                    <Typography variant="body1" className="FileTypeName">
                                      DigiLocker
                                    </Typography>
                                  </Box>
                                </Box>
                              </RadioGroup>
                            </FormControl>
                            <Typography>
                              Note: The file types supported format type is PDF, JPEG & PNG. The
                              maximum uploaded file size is 10MB.
                            </Typography>
                          </DialogContentText>
                        </DialogContent>

                        <DialogActions>
                          <Button
                            disabled={
                              journeyData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                selectedFieldIndex
                              ].kycInput === null
                            }
                            onClick={() =>
                              loantyprapiFire(
                                'uploadDocument',
                                activeStep,
                                wizItemIndex,
                                selectedFieldIndex,
                                ''
                              )
                            }
                            className="mainBtn"
                          >
                            Upload
                          </Button>
                        </DialogActions>
                      </Dialog>

                      {selectedFieldIndex + 1 === wizItem?.selectedFields.length ? (
                        <Box mt={3}>
                          <Typography
                            variant="body1"
                            className="headingLineUp headingLineUpOut"
                            style={{ top: '-8px' }}
                          >
                            Uploaded Documents
                          </Typography>
                          <Box className="viewLeadCard cardTopMinusMarginn">
                            <Box className="displayFlex flexWrap">
                              <Box className="displayFlex flexWrap">
                                {wizItem?.selectedFields.map(
                                  (selectedFieldItem, selectedFieldItemIndex) => {
                                    console.log(
                                      'selectedField',
                                      selectedFieldItem,
                                      selectedFieldItem?.storedField?.documentMap
                                    );

                                    return selectedFieldItem?.storedField?.documentMap !== null &&
                                      selectedFieldItem?.storedField?.documentMap !== '' &&
                                      selectedFieldItem?.storedField?.documentMap !== undefined &&
                                      Object.keys(selectedFieldItem?.storedField?.documentMap)
                                        .length !== 0 ? (
                                      <>
                                        {Object.values(
                                          selectedFieldItem?.storedField?.documentMap
                                        ).map((docItem, docIndex) => {
                                          console.log('des', docItem);
                                          return docItem.isDocumentSubmit ? (
                                            <Box
                                              className="uploadFilePreviewBox uploadFilePreviewGreen"
                                              mb={2}
                                              onClick={(e) => {
                                                const imgDetailsObj = {};
                                                imgDetailsObj.src = docItem.path;
                                                imgDetailsObj.alt =
                                                  selectedFieldItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName;
                                                imgDetailsObj.contentType = docItem.contentType;
                                                docPrevHandler(
                                                  'open',
                                                  JSON.stringify(imgDetailsObj),
                                                  null
                                                );
                                              }}
                                            >
                                              <RemoveRedEyeIcon className="ImageViewIcon" />
                                              <IconButton
                                                onClick={(e) => {
                                                  e.stopPropagation();

                                                  loantyprapiFire(
                                                    'deleteDocument',
                                                    selectedFieldItem?.cardDetailId,
                                                    '',
                                                    selectedFieldItem.journeyCardId,
                                                    ''
                                                  );
                                                }}
                                                className="deleteDoc"
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                              <Typography variant="body2" className="docName">
                                                {!docIndex > 0
                                                  ? selectedFieldItem?.cardFieldMapping
                                                      ?.journeyCardFieldsMaster?.fieldName
                                                  : `${selectedFieldItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName} Back`}
                                              </Typography>
                                            </Box>
                                          ) : (
                                            ''
                                          );
                                        })}
                                      </>
                                    ) : (
                                      ''
                                    );
                                  }
                                )}
                              </Box>
                            </Box>
                            <Box className="">
                              <Typography variant="body2">
                                <Typography variant="span" color="error">
                                  *
                                </Typography>
                                Mandatory Document
                              </Typography>
                              <Typography variant="body2">
                                <sup>#</sup>
                                If document is currently unavailable, the same can be uploaded
                                later.
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      ) : (
                        ''
                      )}
                    </Grid>
                  ) : selectedField?.fieldCurrentIsOcrRequired !== null ? (
                    selectedField?.fieldCurrentIsOcrRequired ? (
                      ''
                    ) : selectedField.cardFieldMapping.fieldDefaultIsOcrRequired !== null ? (
                      selectedField.cardFieldMapping.fieldDefaultIsOcrRequired ? (
                        ''
                      ) : (
                        <Grid item xs={4}>
                          <Typography variant="body1" className="FormLabel">
                            {selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}

                            {selectedField?.fieldCurrentIsMendatory !== null ? (
                              selectedField?.fieldCurrentIsMendatory ? (
                                <Typography variant="span" color="error">
                                  *
                                </Typography>
                              ) : selectedField.cardFieldMapping.fieldDefaultIsMendatory !==
                                null ? (
                                selectedField.cardFieldMapping.fieldDefaultIsMendatory ? (
                                  <Typography variant="span" color="error">
                                    *
                                  </Typography>
                                ) : (
                                  ''
                                )
                              ) : (
                                ''
                              )
                            ) : (
                              ''
                            )}
                          </Typography>
                          {selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                            ?.typeCode === 'DROPDOWN' ? (
                            <Box style={{ position: 'relative' }}>
                              <Select
                                fullWidth
                                inputProps={{
                                  className: `formControl customSelectBox dissabledMenu${
                                    JSON.stringify(selectedField?.storedField?.value) === 'null'
                                      ? ' '
                                      : JSON.stringify(selectedField?.storedField?.value)
                                  }`
                                }}
                                onChange={(event) => {
                                  const inputData = JSON.parse(event.target.value);
                                  const prevData = journeyData;
                                  prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                    selectedFieldIndex
                                  ].storedField.value = inputData;
                                  setJourneyData([...prevData]);
                                  if (
                                    selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                      ?.fieldCode === 'COUNTRY'
                                  ) {
                                    stateCityAction(
                                      inputData.countryId,
                                      wizItemIndex,
                                      'STATE',
                                      countryListRes.allState,
                                      '',
                                      ''
                                    );
                                  } else if (
                                    selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                      ?.fieldCode === 'STATE'
                                  ) {
                                    stateCityAction(
                                      inputData.stateId,
                                      wizItemIndex,
                                      'CITY',
                                      countryListRes.allCity,
                                      '',
                                      ''
                                    );
                                  }
                                }}
                                value={JSON.stringify(selectedField?.storedField?.value)}
                              >
                                <MenuItem value={JSON.stringify(selectedField?.storedField?.value)}>
                                  {`Select ${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}`}
                                </MenuItem>

                                {selectedField?.storedField?.options?.map(
                                  (optionsItem, optionsItemIndex) => (
                                    <MenuItem
                                      key={`${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}_${selectedFieldIndex}_${optionsItemIndex}`}
                                      value={JSON.stringify(optionsItem)}
                                    >
                                      {selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'COUNTRY'
                                        ? optionsItem.countryName
                                        : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                            ?.fieldCode === 'STATE'
                                        ? optionsItem.stateName
                                        : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                            ?.fieldCode === 'CITY'
                                        ? optionsItem.cityName
                                        : optionsItem.defaultValueName}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </Box>
                          ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                              ?.typeCode === 'DATE' ? (
                            <div style={{ position: 'relative' }}>
                              {selectedField?.storedField !== null &&
                              (selectedField?.storedField?.value === null ||
                                selectedField?.storedField?.value === '' ||
                                selectedField?.storedField?.value === undefined) ? (
                                <span className="whenValue"> DD-MM-YYYY</span>
                              ) : (
                                ''
                              )}
                              <TextField
                                type="date"
                                fullWidth
                                id={
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId
                                }
                                inputProps={{ className: 'formControl' }}
                                placeholder={
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldName
                                }
                                onChange={(event) => {
                                  const prevData = journeyData;
                                  prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                    selectedFieldIndex
                                  ].storedField.value = event.target.value;
                                  setJourneyData([...prevData]);
                                }}
                                value={
                                  selectedField?.storedField !== null
                                    ? selectedField?.storedField?.value !== null
                                      ? selectedField?.storedField?.value
                                      : ''
                                    : ''
                                }
                              />
                            </div>
                          ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                              ?.typeCode === 'NUMBER_FIELD' ? (
                            <TextField
                              type="number"
                              fullWidth
                              inputProps={{
                                className: 'formControl'
                              }}
                              id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                              placeholder={
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                              }
                              onChange={(event) => {
                                const prevData = journeyData;
                                prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                  selectedFieldIndex
                                ].storedField.value = event.target.value;
                                setJourneyData([...prevData]);
                              }}
                              value={
                                selectedField?.storedField !== null
                                  ? selectedField?.storedField?.value !== null
                                    ? selectedField?.storedField?.value
                                    : ''
                                  : ''
                              }
                            />
                          ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                              ?.fieldCode === 'CAM_CARD_2_GST_PASSWORD' ? (
                            <TextField
                              fullWidth
                              type="password"
                              autoComplete="new-password"
                              inputProps={{
                                className: 'formControl'
                              }}
                              id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                              placeholder={
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                              }
                              onChange={(event) => {
                                const prevData = journeyData;
                                prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                  selectedFieldIndex
                                ].storedField.value = event.target.value;
                                setJourneyData([...prevData]);
                              }}
                              value={
                                selectedField?.storedField !== null
                                  ? selectedField?.storedField?.value !== null
                                    ? selectedField?.storedField?.value
                                    : ''
                                  : ''
                              }
                              InputProps={{
                                endAdornment:
                                  selectedField?.fieldCurrentIsOcrRequired !== null ? (
                                    selectedField?.fieldCurrentIsOcrRequired ? (
                                      <MdOutlineDocumentScanner color="#4fbbc8" />
                                    ) : selectedField.cardFieldMapping.fieldDefaultIsOcrRequired !==
                                      null ? (
                                      selectedField.cardFieldMapping.fieldDefaultIsOcrRequired ? (
                                        <MdOutlineDocumentScanner color="#4fbbc8" />
                                      ) : (
                                        ''
                                      )
                                    ) : (
                                      ''
                                    )
                                  ) : (
                                    ''
                                  )
                              }}
                            />
                          ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                              ?.fieldCode === 'CAM_CARD_2_MOBILE_PASSWORD' ? (
                            <TextField
                              fullWidth
                              type="password"
                              autoComplete="new-password"
                              inputProps={{
                                className: 'formControl'
                              }}
                              id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                              placeholder={
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                              }
                              onChange={(event) => {
                                const prevData = journeyData;
                                prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                  selectedFieldIndex
                                ].storedField.value = event.target.value;
                                setJourneyData([...prevData]);
                              }}
                              value={
                                selectedField?.storedField !== null
                                  ? selectedField?.storedField?.value !== null
                                    ? selectedField?.storedField?.value
                                    : ''
                                  : ''
                              }
                              InputProps={{
                                endAdornment:
                                  selectedField?.fieldCurrentIsOcrRequired !== null ? (
                                    selectedField?.fieldCurrentIsOcrRequired ? (
                                      <MdOutlineDocumentScanner color="#4fbbc8" />
                                    ) : selectedField.cardFieldMapping.fieldDefaultIsOcrRequired !==
                                      null ? (
                                      selectedField.cardFieldMapping.fieldDefaultIsOcrRequired ? (
                                        <MdOutlineDocumentScanner color="#4fbbc8" />
                                      ) : (
                                        ''
                                      )
                                    ) : (
                                      ''
                                    )
                                  ) : (
                                    ''
                                  )
                              }}
                            />
                          ) : (
                            <TextField
                              fullWidth
                              inputProps={{
                                className: 'formControl'
                              }}
                              id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                              placeholder={
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                              }
                              onChange={(event) => {
                                const prevData = journeyData;
                                prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                  selectedFieldIndex
                                ].storedField.value = event.target.value;
                                setJourneyData([...prevData]);
                              }}
                              value={
                                selectedField?.storedField !== null
                                  ? selectedField?.storedField?.value !== null
                                    ? selectedField?.storedField?.value
                                    : ''
                                  : ''
                              }
                            />
                          )}
                        </Grid>
                      )
                    ) : (
                      <Grid item xs={4}>
                        <Typography variant="body1" className="FormLabel">
                          {selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}

                          {selectedField?.fieldCurrentIsMendatory !== null ? (
                            selectedField?.fieldCurrentIsMendatory ? (
                              <Typography variant="span" color="error">
                                *
                              </Typography>
                            ) : selectedField.cardFieldMapping.fieldDefaultIsMendatory !== null ? (
                              selectedField.cardFieldMapping.fieldDefaultIsMendatory ? (
                                <Typography variant="span" color="error">
                                  *
                                </Typography>
                              ) : (
                                ''
                              )
                            ) : (
                              ''
                            )
                          ) : (
                            ''
                          )}
                        </Typography>
                        {selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                          ?.typeCode === 'DROPDOWN' ? (
                          <Box style={{ position: 'relative' }}>
                            <Select
                              fullWidth
                              inputProps={{
                                className: `formControl customSelectBox dissabledMenu${
                                  JSON.stringify(selectedField?.storedField?.value) === 'null'
                                    ? ' '
                                    : JSON.stringify(selectedField?.storedField?.value)
                                }`
                              }}
                              onChange={(event) => {
                                const inputData = JSON.parse(event.target.value);
                                const prevData = journeyData;
                                prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                  selectedFieldIndex
                                ].storedField.value = inputData;
                                setJourneyData([...prevData]);
                                if (
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldCode === 'COUNTRY'
                                ) {
                                  stateCityAction(
                                    inputData.countryId,
                                    wizItemIndex,
                                    'STATE',
                                    countryListRes.allState,
                                    '',
                                    ''
                                  );
                                } else if (
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldCode === 'STATE'
                                ) {
                                  stateCityAction(
                                    inputData.stateId,
                                    wizItemIndex,
                                    'CITY',
                                    countryListRes.allCity,
                                    '',
                                    ''
                                  );
                                }
                              }}
                              value={JSON.stringify(selectedField?.storedField?.value)}
                            >
                              <MenuItem value={JSON.stringify(selectedField?.storedField?.value)}>
                                {`Select ${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}`}
                              </MenuItem>

                              {selectedField?.storedField?.options?.map(
                                (optionsItem, optionsItemIndex) => (
                                  <MenuItem
                                    key={`${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}_${selectedFieldIndex}_${optionsItemIndex}`}
                                    value={JSON.stringify(optionsItem)}
                                  >
                                    {selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                      ?.fieldCode === 'COUNTRY'
                                      ? optionsItem.countryName
                                      : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                          ?.fieldCode === 'STATE'
                                      ? optionsItem.stateName
                                      : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                          ?.fieldCode === 'CITY'
                                      ? optionsItem.cityName
                                      : optionsItem.defaultValueName}
                                  </MenuItem>
                                )
                              )}
                            </Select>
                          </Box>
                        ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                            ?.typeCode === 'DATE' ? (
                          <div style={{ position: 'relative' }}>
                            {selectedField?.storedField !== null &&
                            (selectedField?.storedField?.value === null ||
                              selectedField?.storedField?.value === '' ||
                              selectedField?.storedField?.value === undefined) ? (
                              <span className="whenValue"> DD-MM-YYYY</span>
                            ) : (
                              ''
                            )}
                            <TextField
                              type="date"
                              fullWidth
                              id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                              inputProps={{ className: 'formControl' }}
                              placeholder={
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                              }
                              onChange={(event) => {
                                const prevData = journeyData;
                                prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                  selectedFieldIndex
                                ].storedField.value = event.target.value;
                                setJourneyData([...prevData]);
                              }}
                              value={
                                selectedField?.storedField !== null
                                  ? selectedField?.storedField?.value !== null
                                    ? selectedField?.storedField?.value
                                    : ''
                                  : ''
                              }
                            />
                          </div>
                        ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                            ?.typeCode === 'NUMBER_FIELD' ? (
                          <TextField
                            type="number"
                            fullWidth
                            inputProps={{
                              className: 'formControl'
                            }}
                            id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                            placeholder={
                              selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                            }
                            onChange={(event) => {
                              const prevData = journeyData;
                              prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                selectedFieldIndex
                              ].storedField.value = event.target.value;
                              setJourneyData([...prevData]);
                            }}
                            value={
                              selectedField?.storedField !== null
                                ? selectedField?.storedField?.value !== null
                                  ? selectedField?.storedField?.value
                                  : ''
                                : ''
                            }
                          />
                        ) : (
                          <TextField
                            fullWidth
                            inputProps={{
                              className: 'formControl'
                            }}
                            id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                            placeholder={
                              selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                            }
                            onChange={(event) => {
                              const prevData = journeyData;
                              prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                selectedFieldIndex
                              ].storedField.value = event.target.value;
                              setJourneyData([...prevData]);
                            }}
                            value={
                              selectedField?.storedField !== null
                                ? selectedField?.storedField?.value !== null
                                  ? selectedField?.storedField?.value
                                  : ''
                                : ''
                            }
                          />
                        )}
                      </Grid>
                    )
                  ) : (
                    <Grid item xs={4}>
                      <Typography variant="body1" className="FormLabel">
                        {selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}
                        {selectedField?.fieldCurrentIsMendatory !== null ? (
                          selectedField?.fieldCurrentIsMendatory ? (
                            <Typography variant="span" color="error">
                              *
                            </Typography>
                          ) : selectedField.cardFieldMapping.fieldDefaultIsMendatory !== null ? (
                            selectedField.cardFieldMapping.fieldDefaultIsMendatory ? (
                              <Typography variant="span" color="error">
                                *
                              </Typography>
                            ) : (
                              ''
                            )
                          ) : (
                            ''
                          )
                        ) : (
                          ''
                        )}
                      </Typography>
                      {selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                        ?.typeCode === 'DROPDOWN' ? (
                        <Box style={{ position: 'relative' }}>
                          <Select
                            fullWidth
                            inputProps={{
                              className: `formControl customSelectBox dissabledMenu${
                                JSON.stringify(selectedField?.storedField?.value) === 'null'
                                  ? ' '
                                  : JSON.stringify(selectedField?.storedField?.value)
                              }`
                            }}
                            onChange={(event) => {
                              const inputData = JSON.parse(event.target.value);
                              const prevData = journeyData;
                              prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                selectedFieldIndex
                              ].storedField.value = inputData;
                              setJourneyData([...prevData]);
                              if (
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                  ?.fieldCode === 'COUNTRY'
                              ) {
                                stateCityAction(
                                  inputData.countryId,
                                  wizItemIndex,
                                  'STATE',
                                  countryListRes.allState,
                                  '',
                                  ''
                                );
                              } else if (
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                  ?.fieldCode === 'STATE'
                              ) {
                                stateCityAction(
                                  inputData.stateId,
                                  wizItemIndex,
                                  'CITY',
                                  countryListRes.allCity,
                                  '',
                                  ''
                                );
                              }
                            }}
                            value={JSON.stringify(selectedField?.storedField?.value)}
                          >
                            <MenuItem value={JSON.stringify(selectedField?.storedField?.value)}>
                              {`Select ${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}`}
                            </MenuItem>

                            {selectedField?.storedField?.options?.map(
                              (optionsItem, optionsItemIndex) => (
                                <MenuItem
                                  key={`${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}_${selectedFieldIndex}_${optionsItemIndex}`}
                                  value={JSON.stringify(optionsItem)}
                                >
                                  {selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldCode === 'COUNTRY'
                                    ? optionsItem.countryName
                                    : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'STATE'
                                    ? optionsItem.stateName
                                    : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'CITY'
                                    ? optionsItem.cityName
                                    : optionsItem.defaultValueName}
                                </MenuItem>
                              )
                            )}
                          </Select>
                        </Box>
                      ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                          ?.typeCode === 'DATE' ? (
                        <div style={{ position: 'relative' }}>
                          {selectedField?.storedField !== null &&
                          (selectedField?.storedField?.value === null ||
                            selectedField?.storedField?.value === '' ||
                            selectedField?.storedField?.value === undefined) ? (
                            <span className="whenValue"> DD-MM-YYYY</span>
                          ) : (
                            ''
                          )}

                          <TextField
                            type="date"
                            fullWidth
                            id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                            inputProps={{ className: 'formControl' }}
                            placeholder={
                              selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                            }
                            onChange={(event) => {
                              const prevData = journeyData;
                              prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                selectedFieldIndex
                              ].storedField.value = event.target.value;
                              setJourneyData([...prevData]);
                            }}
                            value={
                              selectedField?.storedField !== null
                                ? selectedField?.storedField?.value !== null
                                  ? selectedField?.storedField?.value
                                  : ''
                                : ''
                            }
                          />
                        </div>
                      ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                          ?.typeCode === 'NUMBER_FIELD' ? (
                        <TextField
                          type="number"
                          fullWidth
                          inputProps={{
                            className: 'formControl'
                          }}
                          id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                          placeholder={
                            selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                          }
                          onChange={(event) => {
                            const prevData = journeyData;
                            prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                              selectedFieldIndex
                            ].storedField.value = event.target.value;
                            setJourneyData([...prevData]);
                          }}
                          value={
                            selectedField?.storedField !== null
                              ? selectedField?.storedField?.value !== null
                                ? selectedField?.storedField?.value
                                : ''
                              : ''
                          }
                        />
                      ) : (
                        <TextField
                          fullWidth
                          inputProps={{
                            className: 'formControl'
                          }}
                          id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                          placeholder={
                            selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                          }
                          onChange={(event) => {
                            const prevData = journeyData;
                            prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                              selectedFieldIndex
                            ].storedField.value = event.target.value;
                            setJourneyData([...prevData]);
                          }}
                          value={
                            selectedField?.storedField !== null
                              ? selectedField?.storedField?.value !== null
                                ? selectedField?.storedField?.value
                                : ''
                              : ''
                          }
                        />
                      )}
                    </Grid>
                  );
                })}
              </Grid>
            </Box>

            {wizItem?.secondaryCards?.map((secondaryCardsItem, secondaryCardsItemIndex) => (
              <Box
                key={`secondaryCards_${
                  wizItem?.cardCurrentTitle !== null && wizItem?.cardCurrentTitle.trim() !== ''
                    ? wizItem?.cardCurrentTitle
                    : wizItem?.masterCardModel?.cardName
                }_${secondaryCardsItemIndex}`}
                className="viewLeadCard"
                mb={5}
                style={{ position: 'relative' }}
              >
                <Typography variant="body1" className="headingLineUp" style={{ top: '-31px' }}>
                  {wizItem?.cardCurrentTitle !== null && wizItem?.cardCurrentTitle.trim() !== ''
                    ? wizItem?.cardCurrentTitle
                    : wizItem?.masterCardModel?.cardName}{' '}
                  {secondaryCardsItemIndex + 2}
                </Typography>
                <Box
                  className="deleteIcon"
                  style={{ position: 'absolute', top: '-15px', right: '15px' }}
                >
                  <Tooltip title="Delete">
                    <IconButton
                      color="primary"
                      className="squareIconButton"
                      onClick={(e) => {
                        if (secondaryCardsItem?.uniqueIdentifierInformation === null) {
                          const prevData = journeyData;
                          prevData[activeStep]?.selectedCards[wizItemIndex]?.secondaryCards?.splice(
                            secondaryCardsItemIndex,
                            1
                          );
                          setJourneyData([...prevData]);
                        } else {
                          loantyprapiFire(
                            'deleteDocument',
                            '',
                            secondaryCardsItem?.uniqueIdentifierInformation,
                            secondaryCardsItem?.journeyCardId,
                            ''
                          );
                        }
                      }}
                    >
                      <AiFillDelete size={18} />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Grid container spacing={3} style={{ marginLeft: '-12px' }}>
                  {secondaryCardsItem?.selectedFields.map((selectedField, selectedFieldIndex) => {
                    console.log(
                      'secondaryCardsItesecondaryCardsItem',
                      selectedField,
                      secondaryCardsItem
                    );

                    if (
                      selectedField?.storedField !== null &&
                      selectedField?.storedField?.documentMap !== null &&
                      selectedField?.storedField?.documentMap !== '' &&
                      selectedField?.storedField?.documentMap !== undefined &&
                      Object.keys(selectedField?.storedField?.documentMap).length !== 0
                    ) {
                      documentBox += 1;
                    }

                    if (selectedFieldIndex >= 1) {
                      isHeaderRendered = true;
                    } else {
                      isHeaderRendered = false;
                    }

                    return wizItem.masterCardModel.cardType.typeCode === 'DOCUMENT' ? (
                      <Grid
                        key={`secondaryCardsItemIndex_${secondaryCardsItemIndex}`}
                        item
                        xs={12}
                        style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: padTop }}
                      >
                        <Box className={`${isHeaderRendered ? 'notfirstElement' : ''}`}>
                          {!isHeaderRendered && (
                            <>
                              {/* ------ new code -------- */}
                              {wizItem?.cardPurpose?.cardPurposeCode === 'PROMOTER' ||
                              wizItem?.cardPurpose?.cardPurposeCode === 'DIRECTOR' ||
                              wizItem?.cardPurpose?.cardPurposeCode === 'PARTNER' ? (
                                <Grid container spacing={2} alignItems="flex-end" mt={1}>
                                  <Grid item xs>
                                    <FormControl fullWidth className="formGroup">
                                      <Typography variant="body1" className="FormLabel">
                                        Name
                                      </Typography>
                                      <TextField
                                        inputProps={{ className: 'formControl' }}
                                        fullWidth
                                        placeholder="Name"
                                        value={
                                          journeyData[activeStep]?.selectedCards[wizItemIndex]
                                            ?.secondaryCards[secondaryCardsItemIndex]
                                            ?.staticFieldValues?.name
                                        }
                                        onChange={(e) => {
                                          const prevData = journeyData;
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].secondaryCards[
                                            secondaryCardsItemIndex
                                          ].staticFieldValues.name = e.target.value;

                                          setJourneyData([...prevData]);
                                        }}
                                      />
                                    </FormControl>
                                  </Grid>
                                  <Grid item xs>
                                    <FormControl fullWidth className="formGroup">
                                      <Typography variant="body1" className="FormLabel">
                                        Mobile
                                      </Typography>
                                      <TextField
                                        inputProps={{ className: 'formControl' }}
                                        fullWidth
                                        placeholder="Mobile"
                                        value={
                                          journeyData[activeStep]?.selectedCards[wizItemIndex]
                                            ?.secondaryCards[secondaryCardsItemIndex]
                                            ?.staticFieldValues?.mobile
                                        }
                                        onChange={(e) => {
                                          const prevData = journeyData;
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].secondaryCards[
                                            secondaryCardsItemIndex
                                          ].staticFieldValues.mobile = e.target.value;

                                          setJourneyData([...prevData]);
                                        }}
                                      />
                                    </FormControl>
                                  </Grid>
                                  <Grid item xs>
                                    <FormControl fullWidth className="formGroup">
                                      <Typography variant="body1" className="FormLabel">
                                        Email
                                      </Typography>
                                      <TextField
                                        inputProps={{ className: 'formControl' }}
                                        fullWidth
                                        placeholder="Email"
                                        value={
                                          journeyData[activeStep]?.selectedCards[wizItemIndex]
                                            ?.secondaryCards[secondaryCardsItemIndex]
                                            ?.staticFieldValues?.email
                                        }
                                        onChange={(e) => {
                                          const prevData = journeyData;
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].secondaryCards[
                                            secondaryCardsItemIndex
                                          ].staticFieldValues.email = e.target.value;

                                          setJourneyData([...prevData]);
                                        }}
                                      />
                                    </FormControl>
                                  </Grid>
                                  <Grid item xs="auto">
                                    <Box>
                                      <Button
                                        style={{ padding: '9px 20px' }}
                                        className="mainBtn mainBtnSmall"
                                        onClick={(e) => {
                                          let allowToFireApi = true;
                                          let validateFld = true;
                                          journeyData[activeStep].selectedCards.every(
                                            (selectedCardsItem) => {
                                              if (selectedCardsItem.secondaryCards.length > 0) {
                                                selectedCardsItem.secondaryCards.forEach(
                                                  (selItem) => {
                                                    console.log(
                                                      'secondaryCardsItesecondaryCardsItem',
                                                      selItem.staticFieldValues
                                                    );
                                                    if (
                                                      selItem.staticFieldValues.name === null ||
                                                      selItem.staticFieldValues.name === ''
                                                    ) {
                                                      const imgDetailsObj = {};
                                                      imgDetailsObj.src = '';
                                                      imgDetailsObj.alt = 'Enter Name';
                                                      imgDetailsObj.contentType =
                                                        'mobilenoValidation';
                                                      docPrevHandler(
                                                        'open',
                                                        JSON.stringify(imgDetailsObj),
                                                        null
                                                      );

                                                      validateFld = false;
                                                    } else if (
                                                      selItem.staticFieldValues.mobile === null ||
                                                      selItem.staticFieldValues.mobile === ''
                                                    ) {
                                                      const imgDetailsObj = {};
                                                      imgDetailsObj.src = '';
                                                      imgDetailsObj.alt = 'Enter Mobile No';
                                                      imgDetailsObj.contentType =
                                                        'mobilenoValidation';
                                                      docPrevHandler(
                                                        'open',
                                                        JSON.stringify(imgDetailsObj),
                                                        null
                                                      );
                                                      validateFld = false;
                                                    } else if (
                                                      selItem.staticFieldValues.email === null ||
                                                      selItem.staticFieldValues.email === ''
                                                    ) {
                                                      const imgDetailsObj = {};
                                                      imgDetailsObj.src = '';
                                                      imgDetailsObj.alt = 'Enter Email Id';
                                                      imgDetailsObj.contentType =
                                                        'mobilenoValidation';
                                                      docPrevHandler(
                                                        'open',
                                                        JSON.stringify(imgDetailsObj),
                                                        null
                                                      );
                                                      validateFld = false;
                                                    }
                                                  }
                                                );

                                                if (validateFld === true) {
                                                  let cardSeqValidate =
                                                    selectedCardsItem.secondaryCards.map(
                                                      (itemnext) =>
                                                        Object.keys(itemnext.staticFieldValues)
                                                          .length > 0
                                                          ? itemnext.staticFieldValues.mobile
                                                          : ''
                                                    );

                                                  cardSeqValidate = [
                                                    ...cardSeqValidate,
                                                    selectedCardsItem.staticFieldValues.mobile
                                                  ];

                                                  const isDuplicatecardCurrentSeqValidate =
                                                    cardSeqValidate.some(
                                                      (item, idx) =>
                                                        cardSeqValidate.indexOf(item) !== idx
                                                    );

                                                  if (isDuplicatecardCurrentSeqValidate === true) {
                                                    const imgDetailsObj = {};
                                                    imgDetailsObj.src = '';
                                                    imgDetailsObj.alt =
                                                      'Mobile no should be unique for each director document';
                                                    imgDetailsObj.contentType =
                                                      'mobilenoValidation';
                                                    docPrevHandler(
                                                      'open',
                                                      JSON.stringify(imgDetailsObj),
                                                      null
                                                    );

                                                    allowToFireApi = false;
                                                  }
                                                }
                                              }
                                              return allowToFireApi;
                                            }
                                          );

                                          if (allowToFireApi === true && validateFld === true) {
                                            loantyprapiFire(
                                              'uploadDocument',
                                              activeStep,
                                              wizItemIndex,
                                              '',
                                              secondaryCardsItemIndex
                                            );
                                          }
                                        }}
                                      >
                                        Save
                                      </Button>
                                    </Box>
                                  </Grid>
                                </Grid>
                              ) : (
                                ''
                              )}

                              <Typography
                                variant="body2"
                                marginBottom={2}
                                marginTop={2}
                                style={{
                                  display:
                                    secondaryCardsItem.isDataCapture === false ? 'block' : 'none'
                                }}
                                className={
                                  secondaryCardsItem.isCardDisable
                                    ? 'disabledDocument'
                                    : 'enabledDocument'
                                }
                              >
                                For faster processing of your application form, please scan and
                                upload a pdf/jpg file for the documents mentioned below.
                              </Typography>
                            </>
                          )}

                          <Box
                            style={{
                              display: secondaryCardsItem.isDataCapture === false ? 'block' : 'none'
                            }}
                          >
                            <TableContainer
                              component={Paper}
                              sx={{ borderRadius: '0.5rem 0.5rem 0 0', marginBottom: '0' }}
                            >
                              <Table
                                aria-label="customized table"
                                size="small"
                                padding="normal" /* ------ new code -------- */
                                className={
                                  secondaryCardsItem.isCardDisable
                                    ? 'disabledDocument'
                                    : 'enabledDocument'
                                }
                                /* ------ new code -------- */
                              >
                                {!isHeaderRendered && (
                                  <TableHead className="tableHead">
                                    <TableRow>
                                      <TableCell
                                        style={{ width: '30%', borderBottom: borderBottomo }}
                                      >
                                        Applicant Documents
                                      </TableCell>
                                      <TableCell
                                        style={{ width: '15%', borderBottom: borderBottomo }}
                                      >
                                        Action
                                      </TableCell>
                                      <TableCell
                                        style={{ width: '15%', borderBottom: borderBottomo }}
                                      >
                                        Will Provide Later
                                      </TableCell>
                                      <TableCell
                                        style={{ width: '15%', borderBottom: borderBottomo }}
                                      >
                                        Unable to Submit
                                      </TableCell>
                                      <TableCell
                                        style={{ width: '20%', borderBottom: borderBottomo }}
                                      >
                                        Remarks
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                )}

                                <TableBody>
                                  {selectedField.isDocumentSubmit ? (
                                    <TableRow
                                      key={selectedFieldIndex}
                                      className={`${isHeaderRendered ? '' : 'firstElement'}`}
                                    >
                                      <TableCell
                                        style={{ width: '30%', borderBottom: borderBottomo }}
                                      >
                                        {
                                          selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                            ?.fieldName
                                        }
                                        {selectedField?.fieldCurrentIsMendatory !== null ? (
                                          selectedField?.fieldCurrentIsMendatory ? (
                                            <Typography variant="span" color="error">
                                              *
                                            </Typography>
                                          ) : selectedField.cardFieldMapping
                                              .fieldDefaultIsMendatory !== null ? (
                                            selectedField.cardFieldMapping
                                              .fieldDefaultIsMendatory ? (
                                              <Typography variant="span" color="error">
                                                *
                                              </Typography>
                                            ) : (
                                              ''
                                            )
                                          ) : (
                                            ''
                                          )
                                        ) : (
                                          ''
                                        )}
                                      </TableCell>
                                      <TableCell
                                        style={{ width: '15%', borderBottom: borderBottomo }}
                                      >
                                        <IconButton
                                          aria-label="Example"
                                          className="docIcon"
                                          onClick={(e) => {
                                            const prevData = journeyData;
                                            prevData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].secondaryCards[
                                              secondaryCardsItemIndex
                                            ].selectedFields[selectedFieldIndex].isOpen = true;
                                            setJourneyData([...prevData]);
                                          }}
                                        >
                                          <MdUploadFile />
                                        </IconButton>
                                      </TableCell>
                                      <TableCell
                                        style={{ width: '15%', borderBottom: borderBottomo }}
                                      >
                                        <Checkbox
                                          size="small"
                                          checked={
                                            journeyData[activeStep].selectedCards[wizItemIndex]
                                              .secondaryCards[secondaryCardsItemIndex]
                                              .selectedFields[selectedFieldIndex].isProvideLater
                                          }
                                          disabled={
                                            journeyData[activeStep].selectedCards[wizItemIndex]
                                              .secondaryCards[secondaryCardsItemIndex]
                                              .selectedFields[selectedFieldIndex].isUnableToSubmit
                                          }
                                          onChange={(e) => {
                                            const prevData = journeyData;
                                            prevData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].secondaryCards[
                                              secondaryCardsItemIndex
                                            ].selectedFields[selectedFieldIndex].isProvideLater =
                                              e.target.checked;

                                            setJourneyData([...prevData]);
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell
                                        style={{ width: '15%', borderBottom: borderBottomo }}
                                      >
                                        <Checkbox
                                          size="small"
                                          checked={
                                            journeyData[activeStep].selectedCards[wizItemIndex]
                                              .secondaryCards[secondaryCardsItemIndex]
                                              .selectedFields[selectedFieldIndex].isUnableToSubmit
                                          }
                                          disabled={
                                            journeyData[activeStep].selectedCards[wizItemIndex]
                                              .secondaryCards[secondaryCardsItemIndex]
                                              .selectedFields[selectedFieldIndex].isProvideLater
                                          }
                                          onChange={(e) => {
                                            const prevData = journeyData;

                                            prevData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].secondaryCards[
                                              secondaryCardsItemIndex
                                            ].selectedFields[selectedFieldIndex].isUnableToSubmit =
                                              e.target.checked;

                                            setJourneyData([...prevData]);
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell
                                        style={{ width: '20%', borderBottom: borderBottomo }}
                                      >
                                        <TextField
                                          fullWidth
                                          size="small"
                                          inputProps={{
                                            className: 'formControl formControlRemark'
                                          }}
                                          placeholder="Remarks"
                                          value={
                                            journeyData[activeStep].selectedCards[wizItemIndex]
                                              .secondaryCards[secondaryCardsItemIndex]
                                              .selectedFields[selectedFieldIndex].remarks
                                          }
                                          onChange={(e) => {
                                            const prevData = journeyData;

                                            prevData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].secondaryCards[
                                              secondaryCardsItemIndex
                                            ].selectedFields[selectedFieldIndex].remarks =
                                              e.target.value;

                                            setJourneyData([...prevData]);
                                          }}
                                        />
                                      </TableCell>
                                    </TableRow>
                                  ) : (
                                    ''
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>
                        </Box>
                        <Dialog
                          className="PopupBox"
                          open={
                            journeyData[activeStep].selectedCards[wizItemIndex].secondaryCards[
                              secondaryCardsItemIndex
                            ].selectedFields[selectedFieldIndex].isOpen
                          }
                          onClose={() =>
                            handleClose(
                              activeStep,
                              wizItemIndex,
                              selectedFieldIndex,
                              secondaryCardsItemIndex
                            )
                          }
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                        >
                          <DialogTitle id="alert-dialog-title" className="popupHeadingg">
                            <Typography variant="h6" className="popupTitlee">
                              Upload Document
                            </Typography>
                            <IconButton
                              onClick={() =>
                                handleClose(
                                  activeStep,
                                  wizItemIndex,
                                  selectedFieldIndex,
                                  secondaryCardsItemIndex
                                )
                              }
                              size="small"
                            >
                              <CloseIcon />
                            </IconButton>
                          </DialogTitle>

                          <DialogContent dividers className="PopupContent">
                            <DialogContentText id="alert-dialog-description">
                              <FormControl sx={{ width: '100%' }}>
                                <RadioGroup
                                  aria-labelledby="demo-radio-buttons-group-label"
                                  defaultValue="Local File"
                                  name="radio-buttons-group"
                                >
                                  <Box container className="uploadPopupRow">
                                    <Box className="uploadPopupInnerRow">
                                      <FormControlLabel
                                        value="Local File"
                                        control={<Radio size="small" />}
                                        label=""
                                        sx={{ marginRight: '0.5rem' }}
                                      />
                                      <Typography variant="caption" className="UploadPopupIcon">
                                        <MdUpload className="UploadIcon" />
                                      </Typography>
                                      <Typography
                                        variant="body1"
                                        marginRight={1}
                                        className="FileTypeName"
                                      >
                                        Local Files
                                      </Typography>
                                      <input
                                        id="kycUploaderSecondary"
                                        className="Fileupload hideForView"
                                        onChange={(e) => {
                                          const filename = e.target.files[0];
                                          const prevData = journeyData;
                                          if (filename.size > 0) {
                                            prevData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].secondaryCards[
                                              secondaryCardsItemIndex
                                            ].selectedFields[selectedFieldIndex].file = filename;
                                            prevData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].secondaryCards[
                                              secondaryCardsItemIndex
                                            ].selectedFields[selectedFieldIndex].kycInput =
                                              filename.name;
                                          } else {
                                            prevData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].secondaryCards[
                                              secondaryCardsItemIndex
                                            ].selectedFields[selectedFieldIndex].file = null;
                                            prevData[activeStep].selectedCards[
                                              wizItemIndex
                                            ].secondaryCards[
                                              secondaryCardsItemIndex
                                            ].selectedFields[selectedFieldIndex].kycInput = '';
                                            const imgDetailsObj = {};
                                            imgDetailsObj.src = '';
                                            imgDetailsObj.alt =
                                              'File size must be greater then 0 kb';
                                            imgDetailsObj.contentType = 'content';
                                            docPrevHandler(
                                              'open',
                                              JSON.stringify(imgDetailsObj),
                                              null
                                            );
                                          }
                                          setJourneyData([...prevData]);
                                        }}
                                        type="file"
                                      />
                                      <ShowInputBox
                                        val={
                                          journeyData[activeStep].selectedCards[wizItemIndex]
                                            .secondaryCards[secondaryCardsItemIndex].selectedFields[
                                            selectedFieldIndex
                                          ].kycInput
                                        }
                                      />
                                      <Button
                                        type="button"
                                        onClick={() => {
                                          uploadKycFile('kycUploaderSecondary');
                                        }}
                                        className="uploadBtn"
                                      >
                                        Browse
                                      </Button>
                                    </Box>

                                    {selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                      ?.fieldCode === 'AADHAR_CARD' ? (
                                      <Box className="uploadPopupInnerRow">
                                        <FormControlLabel
                                          value="Local File"
                                          control={<Radio size="small" />}
                                          label=""
                                          sx={{ marginRight: '0.5rem' }}
                                        />
                                        <Typography variant="caption" className="UploadPopupIcon">
                                          <MdUpload className="UploadIcon" />
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          marginRight={1}
                                          className="FileTypeName"
                                        >
                                          Local Files
                                        </Typography>
                                        <input
                                          id="kycBackUploaderSecondary"
                                          className="Fileupload hideForView"
                                          onChange={(e) => {
                                            const filename = e.target.files[0];
                                            const prevData = journeyData;
                                            if (filename.size > 0) {
                                              prevData[activeStep].selectedCards[
                                                wizItemIndex
                                              ].secondaryCards[
                                                secondaryCardsItemIndex
                                              ].selectedFields[selectedFieldIndex].fileBack =
                                                filename;
                                              prevData[activeStep].selectedCards[
                                                wizItemIndex
                                              ].secondaryCards[
                                                secondaryCardsItemIndex
                                              ].selectedFields[selectedFieldIndex].kycInputBack =
                                                filename.name;
                                            } else {
                                              prevData[activeStep].selectedCards[
                                                wizItemIndex
                                              ].secondaryCards[
                                                secondaryCardsItemIndex
                                              ].selectedFields[selectedFieldIndex].fileBack = null;
                                              prevData[activeStep].selectedCards[
                                                wizItemIndex
                                              ].secondaryCards[
                                                secondaryCardsItemIndex
                                              ].selectedFields[selectedFieldIndex].kycInputBack =
                                                '';
                                              const imgDetailsObj = {};
                                              imgDetailsObj.src = '';
                                              imgDetailsObj.alt =
                                                'File size must be greater then 0 kb';
                                              imgDetailsObj.contentType = 'content';
                                              docPrevHandler(
                                                'open',
                                                JSON.stringify(imgDetailsObj),
                                                null
                                              );
                                            }
                                            setJourneyData([...prevData]);
                                          }}
                                          type="file"
                                        />
                                        <TextField
                                          value={
                                            journeyData[activeStep].selectedCards[wizItemIndex]
                                              .secondaryCards[secondaryCardsItemIndex]
                                              .selectedFields[selectedFieldIndex].kycInputBack
                                          }
                                          inputProps={{ className: 'TextField', readOnly: true }}
                                          className="TextFieldGroup"
                                        />
                                        <Button
                                          type="button"
                                          onClick={() => {
                                            uploadKycBackFile('kycBackUploaderSecondary');
                                          }}
                                          className="uploadBtn"
                                        >
                                          Browse
                                        </Button>
                                      </Box>
                                    ) : (
                                      ''
                                    )}

                                    <FormControl className="PassProtectB" defaultValue="No">
                                      <FormLabel
                                        id="demo-row-radio-buttons-group-label"
                                        sx={{ marginRight: '0.5rem' }}
                                      >
                                        Is your file password protected?
                                      </FormLabel>
                                      <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        value={
                                          journeyData[activeStep].selectedCards[wizItemIndex]
                                            .secondaryCards[secondaryCardsItemIndex].selectedFields[
                                            selectedFieldIndex
                                          ].kycPassProcted
                                        }
                                        onChange={(e) => {
                                          const prevData = journeyData;
                                          prevData[activeStep].selectedCards[
                                            wizItemIndex
                                          ].secondaryCards[secondaryCardsItemIndex].selectedFields[
                                            selectedFieldIndex
                                          ].kycPassProcted = e.target.value;

                                          setJourneyData([...prevData]);
                                        }}
                                      >
                                        <FormControlLabel
                                          value="Yes"
                                          control={<Radio size="small" />}
                                          label="Yes"
                                        />
                                        <FormControlLabel
                                          value="No"
                                          control={<Radio size="small" />}
                                          label="No"
                                        />
                                      </RadioGroup>
                                    </FormControl>
                                    {journeyData[activeStep]?.selectedCards[wizItemIndex]
                                      ?.secondaryCards[secondaryCardsItemIndex]?.selectedFields[
                                      selectedFieldIndex
                                    ]?.kycPassProcted === 'Yes' && (
                                      <TextField
                                        className="TextFieldGroup"
                                        inputProps={{ className: 'TextField' }}
                                        fullWidth="true"
                                      />
                                    )}
                                  </Box>
                                  <Box container className="uploadPopupRow">
                                    <Box className="uploadPopupInnerRow">
                                      <FormControlLabel
                                        value="Google Drive"
                                        control={<Radio size="small" />}
                                        label=""
                                        sx={{ marginRight: '0.5rem' }}
                                      />
                                      <Typography variant="caption" className="UploadPopupIcon">
                                        <img
                                          src="../static/icons/googleDrive.svg"
                                          alt="Google Drive"
                                        />
                                      </Typography>
                                      <Typography variant="body1" className="FileTypeName">
                                        Google Drive
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <Box container className="uploadPopupRow">
                                    <Box className="uploadPopupInnerRow">
                                      <FormControlLabel
                                        value="Dropbox"
                                        control={<Radio size="small" />}
                                        label=""
                                        sx={{ marginRight: '0.5rem' }}
                                      />
                                      <Typography variant="caption" className="UploadPopupIcon">
                                        <img src="../static/icons/dropBox.svg" alt="Drop Box" />
                                      </Typography>
                                      <Typography variant="body1" className="FileTypeName">
                                        Dropbox
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <Box container className="uploadPopupRow">
                                    <Box className="uploadPopupInnerRow">
                                      <FormControlLabel
                                        value="Digiloker"
                                        control={<Radio size="small" />}
                                        label=""
                                        sx={{ marginRight: '0.5rem' }}
                                      />
                                      <Typography variant="caption" className="UploadPopupIcon">
                                        <img
                                          src="../static/icons/digilocker.svg"
                                          alt="Digi Locker"
                                        />
                                      </Typography>
                                      <Typography variant="body1" className="FileTypeName">
                                        DigiLocker
                                      </Typography>
                                    </Box>
                                  </Box>
                                </RadioGroup>
                              </FormControl>
                              <Typography>
                                Note: The file types supported format type is PDF, JPEG & PNG. The
                                maximum uploaded file size is 10MB.
                              </Typography>
                            </DialogContentText>
                          </DialogContent>

                          <DialogActions>
                            <Button
                              disabled={
                                journeyData[activeStep].selectedCards[wizItemIndex].secondaryCards[
                                  secondaryCardsItemIndex
                                ].selectedFields[selectedFieldIndex].kycInput === null
                              }
                              onClick={() =>
                                loantyprapiFire(
                                  'uploadDocument',
                                  activeStep,
                                  wizItemIndex,
                                  selectedFieldIndex,
                                  secondaryCardsItemIndex
                                )
                              }
                              className="mainBtn"
                            >
                              Upload
                            </Button>
                          </DialogActions>
                        </Dialog>

                        {selectedFieldIndex + 1 === secondaryCardsItem?.selectedFields.length ? (
                          <Box mt={3}>
                            <Typography
                              variant="body1"
                              className="headingLineUp headingLineUpOut"
                              style={{ top: '-8px' }}
                            >
                              Uploaded Documents
                            </Typography>
                            <Box className="viewLeadCard cardTopMinusMarginn">
                              <Box className="displayFlex flexWrap">
                                <Box className="displayFlex flexWrap">
                                  {secondaryCardsItem?.selectedFields.map(
                                    (selectedFieldItem, selectedFieldItemIndex) => {
                                      console.log(
                                        'selectedField',
                                        selectedFieldItem,
                                        selectedFieldItem?.storedField?.documentMap
                                      );

                                      return selectedFieldItem?.storedField?.documentMap !== null &&
                                        selectedFieldItem?.storedField?.documentMap !== undefined &&
                                        selectedFieldItem?.storedField?.documentMap !== '' &&
                                        Object.keys(selectedFieldItem?.storedField?.documentMap)
                                          .length !== 0 ? (
                                        <>
                                          {Object.values(
                                            selectedFieldItem?.storedField?.documentMap
                                          ).map((docItem, docIndex) => {
                                            console.log('des', docItem);
                                            return docItem.isDocumentSubmit ? (
                                              <Box
                                                className="uploadFilePreviewBox uploadFilePreviewGreen"
                                                mb={2}
                                                onClick={(e) => {
                                                  const imgDetailsObj = {};
                                                  imgDetailsObj.src = docItem.path;
                                                  imgDetailsObj.alt =
                                                    selectedFieldItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName;
                                                  imgDetailsObj.contentType = docItem.contentType;
                                                  docPrevHandler(
                                                    'open',
                                                    JSON.stringify(imgDetailsObj),
                                                    null
                                                  );
                                                }}
                                              >
                                                <RemoveRedEyeIcon className="ImageViewIcon" />
                                                <IconButton
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    console.log(
                                                      'secondaryCardsItemsecondaryCardsItem',
                                                      secondaryCardsItem
                                                    );
                                                    loantyprapiFire(
                                                      'deleteDocument',
                                                      selectedFieldItem?.cardDetailId,
                                                      secondaryCardsItem?.uniqueIdentifierInformation,
                                                      selectedFieldItem.journeyCardId,
                                                      ''
                                                    );
                                                  }}
                                                  className="deleteDoc"
                                                >
                                                  <CloseIcon fontSize="small" />
                                                </IconButton>
                                                <Typography variant="body2" className="docName">
                                                  {!docIndex > 0
                                                    ? selectedFieldItem?.cardFieldMapping
                                                        ?.journeyCardFieldsMaster?.fieldName
                                                    : `${selectedFieldItem?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName} Back`}
                                                </Typography>
                                              </Box>
                                            ) : (
                                              ''
                                            );
                                          })}
                                        </>
                                      ) : (
                                        ''
                                      );
                                    }
                                  )}
                                </Box>
                              </Box>
                              <Box className="">
                                <Typography variant="body2">
                                  <Typography variant="span" color="error">
                                    *
                                  </Typography>
                                  Mandatory Document
                                </Typography>
                                <Typography variant="body2">
                                  <sup>#</sup>
                                  If document is currently unavailable, the same can be uploaded
                                  later.
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        ) : (
                          ''
                        )}
                      </Grid>
                    ) : selectedField?.fieldCurrentIsOcrRequired !== null ? (
                      selectedField?.fieldCurrentIsOcrRequired ? (
                        ''
                      ) : selectedField.cardFieldMapping.fieldDefaultIsOcrRequired !== null ? (
                        selectedField.cardFieldMapping.fieldDefaultIsOcrRequired ? (
                          ''
                        ) : (
                          <Grid item xs={4}>
                            <Typography variant="body1" className="FormLabel">
                              {selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}

                              {selectedField?.fieldCurrentIsMendatory !== null ? (
                                selectedField?.fieldCurrentIsMendatory ? (
                                  <Typography variant="span" color="error">
                                    *
                                  </Typography>
                                ) : selectedField.cardFieldMapping.fieldDefaultIsMendatory !==
                                  null ? (
                                  selectedField.cardFieldMapping.fieldDefaultIsMendatory ? (
                                    <Typography variant="span" color="error">
                                      *
                                    </Typography>
                                  ) : (
                                    ''
                                  )
                                ) : (
                                  ''
                                )
                              ) : (
                                ''
                              )}
                            </Typography>
                            {selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                              ?.typeCode === 'DROPDOWN' ? (
                              <Box style={{ position: 'relative' }}>
                                <Select
                                  fullWidth
                                  inputProps={{
                                    className: `formControl customSelectBox dissabledMenu${
                                      JSON.stringify(selectedField?.storedField?.value) === 'null'
                                        ? ' '
                                        : JSON.stringify(selectedField?.storedField?.value)
                                    }`
                                  }}
                                  onChange={(event) => {
                                    const inputData = JSON.parse(event.target.value);
                                    const prevData = journeyData;
                                    prevData[activeStep].selectedCards[wizItemIndex].secondaryCards[
                                      secondaryCardsItemIndex
                                    ].selectedFields[selectedFieldIndex].storedField.value =
                                      inputData;
                                    setJourneyData([...prevData]);
                                    if (
                                      selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'COUNTRY'
                                    ) {
                                      stateCityAction(
                                        inputData.countryId,
                                        wizItemIndex,
                                        'STATE',
                                        countryListRes.allState,
                                        secondaryCardsItemIndex,
                                        ''
                                      );
                                    } else if (
                                      selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'STATE'
                                    ) {
                                      stateCityAction(
                                        inputData.stateId,
                                        wizItemIndex,
                                        'CITY',
                                        countryListRes.allCity,
                                        secondaryCardsItemIndex,
                                        ''
                                      );
                                    }
                                  }}
                                  value={JSON.stringify(selectedField?.storedField?.value)}
                                >
                                  <MenuItem
                                    value={JSON.stringify(selectedField?.storedField?.value)}
                                  >
                                    {`Select ${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}`}
                                  </MenuItem>

                                  {selectedField?.storedField?.options?.map(
                                    (optionsItem, optionsItemIndex) => (
                                      <MenuItem
                                        key={`${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}_${selectedFieldIndex}_${optionsItemIndex}`}
                                        value={JSON.stringify(optionsItem)}
                                      >
                                        {selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                          ?.fieldCode === 'COUNTRY'
                                          ? optionsItem.countryName
                                          : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                              ?.fieldCode === 'STATE'
                                          ? optionsItem.stateName
                                          : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                              ?.fieldCode === 'CITY'
                                          ? optionsItem.cityName
                                          : optionsItem.defaultValueName}
                                      </MenuItem>
                                    )
                                  )}
                                </Select>
                              </Box>
                            ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                                ?.typeCode === 'DATE' ? (
                              <div style={{ position: 'relative' }}>
                                {selectedField?.storedField !== null &&
                                (selectedField?.storedField?.value === null ||
                                  selectedField?.storedField?.value === '' ||
                                  selectedField?.storedField?.value === undefined) ? (
                                  <span className="whenValue"> DD-MM-YYYY</span>
                                ) : (
                                  ''
                                )}
                                <TextField
                                  type="date"
                                  fullWidth
                                  id={
                                    selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                      ?.fieldId
                                  }
                                  inputProps={{ className: 'formControl' }}
                                  placeholder={
                                    selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                      ?.fieldName
                                  }
                                  onChange={(event) => {
                                    const prevData = journeyData;
                                    prevData[activeStep].selectedCards[wizItemIndex].secondaryCards[
                                      secondaryCardsItemIndex
                                    ].selectedFields[selectedFieldIndex].storedField.value =
                                      event.target.value;
                                    setJourneyData([...prevData]);
                                  }}
                                  value={
                                    selectedField?.storedField !== null
                                      ? selectedField?.storedField?.value !== null
                                        ? selectedField?.storedField?.value
                                        : ''
                                      : ''
                                  }
                                />
                              </div>
                            ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                                ?.typeCode === 'NUMBER_FIELD' ? (
                              <TextField
                                type="number"
                                fullWidth
                                inputProps={{
                                  className: 'formControl'
                                }}
                                id={`${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}_${secondaryCardsItemIndex}`}
                                placeholder={
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldName
                                }
                                onChange={(event) => {
                                  const prevData = journeyData;
                                  prevData[activeStep].selectedCards[wizItemIndex].secondaryCards[
                                    secondaryCardsItemIndex
                                  ].selectedFields[selectedFieldIndex].storedField.value =
                                    event.target.value;
                                  setJourneyData([...prevData]);
                                }}
                                value={
                                  selectedField?.storedField !== null
                                    ? selectedField?.storedField?.value !== null
                                      ? selectedField?.storedField?.value
                                      : ''
                                    : ''
                                }
                              />
                            ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                ?.fieldCode === 'CAM_CARD_2_GST_PASSWORD' ? (
                              <TextField
                                fullWidth
                                type="password"
                                autoComplete="new-password"
                                inputProps={{
                                  className: 'formControl'
                                }}
                                id={
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId
                                }
                                placeholder={
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldName
                                }
                                onChange={(event) => {
                                  const prevData = journeyData;
                                  prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                    selectedFieldIndex
                                  ].storedField.value = event.target.value;
                                  setJourneyData([...prevData]);
                                }}
                                value={
                                  selectedField?.storedField !== null
                                    ? selectedField?.storedField?.value !== null
                                      ? selectedField?.storedField?.value
                                      : ''
                                    : ''
                                }
                                InputProps={{
                                  endAdornment:
                                    selectedField?.fieldCurrentIsOcrRequired !== null ? (
                                      selectedField?.fieldCurrentIsOcrRequired ? (
                                        <MdOutlineDocumentScanner color="#4fbbc8" />
                                      ) : selectedField.cardFieldMapping
                                          .fieldDefaultIsOcrRequired !== null ? (
                                        selectedField.cardFieldMapping.fieldDefaultIsOcrRequired ? (
                                          <MdOutlineDocumentScanner color="#4fbbc8" />
                                        ) : (
                                          ''
                                        )
                                      ) : (
                                        ''
                                      )
                                    ) : (
                                      ''
                                    )
                                }}
                              />
                            ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                ?.fieldCode === 'CAM_CARD_2_MOBILE_PASSWORD' ? (
                              <TextField
                                fullWidth
                                type="password"
                                autoComplete="new-password"
                                inputProps={{
                                  className: 'formControl'
                                }}
                                id={
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId
                                }
                                placeholder={
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldName
                                }
                                onChange={(event) => {
                                  const prevData = journeyData;
                                  prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                    selectedFieldIndex
                                  ].storedField.value = event.target.value;
                                  setJourneyData([...prevData]);
                                }}
                                value={
                                  selectedField?.storedField !== null
                                    ? selectedField?.storedField?.value !== null
                                      ? selectedField?.storedField?.value
                                      : ''
                                    : ''
                                }
                                InputProps={{
                                  endAdornment:
                                    selectedField?.fieldCurrentIsOcrRequired !== null ? (
                                      selectedField?.fieldCurrentIsOcrRequired ? (
                                        <MdOutlineDocumentScanner color="#4fbbc8" />
                                      ) : selectedField.cardFieldMapping
                                          .fieldDefaultIsOcrRequired !== null ? (
                                        selectedField.cardFieldMapping.fieldDefaultIsOcrRequired ? (
                                          <MdOutlineDocumentScanner color="#4fbbc8" />
                                        ) : (
                                          ''
                                        )
                                      ) : (
                                        ''
                                      )
                                    ) : (
                                      ''
                                    )
                                }}
                              />
                            ) : (
                              <TextField
                                fullWidth
                                inputProps={{
                                  className: 'formControl'
                                }}
                                id={
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId
                                }
                                placeholder={
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldName
                                }
                                onChange={(event) => {
                                  const prevData = journeyData;
                                  prevData[activeStep].selectedCards[wizItemIndex].secondaryCards[
                                    secondaryCardsItemIndex
                                  ].selectedFields[selectedFieldIndex].storedField.value =
                                    event.target.value;
                                  setJourneyData([...prevData]);
                                }}
                                value={
                                  selectedField?.storedField !== null
                                    ? selectedField?.storedField?.value !== null
                                      ? selectedField?.storedField?.value
                                      : ''
                                    : ''
                                }
                              />
                            )}
                          </Grid>
                        )
                      ) : (
                        <Grid item xs={4}>
                          <Typography variant="body1" className="FormLabel">
                            {selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}

                            {selectedField?.fieldCurrentIsMendatory !== null ? (
                              selectedField?.fieldCurrentIsMendatory ? (
                                <Typography variant="span" color="error">
                                  *
                                </Typography>
                              ) : selectedField.cardFieldMapping.fieldDefaultIsMendatory !==
                                null ? (
                                selectedField.cardFieldMapping.fieldDefaultIsMendatory ? (
                                  <Typography variant="span" color="error">
                                    *
                                  </Typography>
                                ) : (
                                  ''
                                )
                              ) : (
                                ''
                              )
                            ) : (
                              ''
                            )}
                          </Typography>
                          {selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                            ?.typeCode === 'DROPDOWN' ? (
                            <Box style={{ position: 'relative' }}>
                              <Select
                                fullWidth
                                inputProps={{
                                  className: `formControl customSelectBox dissabledMenu${
                                    JSON.stringify(selectedField?.storedField?.value) === 'null'
                                      ? ' '
                                      : JSON.stringify(selectedField?.storedField?.value)
                                  }`
                                }}
                                onChange={(event) => {
                                  const inputData = JSON.parse(event.target.value);
                                  const prevData = journeyData;
                                  prevData[activeStep].selectedCards[wizItemIndex].secondaryCards[
                                    secondaryCardsItemIndex
                                  ].selectedFields[selectedFieldIndex].storedField.value =
                                    inputData;
                                  setJourneyData([...prevData]);
                                  if (
                                    selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                      ?.fieldCode === 'COUNTRY'
                                  ) {
                                    stateCityAction(
                                      inputData.countryId,
                                      wizItemIndex,
                                      'STATE',
                                      countryListRes.allState,
                                      secondaryCardsItemIndex,
                                      ''
                                    );
                                  } else if (
                                    selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                      ?.fieldCode === 'STATE'
                                  ) {
                                    stateCityAction(
                                      inputData.stateId,
                                      wizItemIndex,
                                      'CITY',
                                      countryListRes.allCity,
                                      secondaryCardsItemIndex,
                                      ''
                                    );
                                  }
                                }}
                                value={JSON.stringify(selectedField?.storedField?.value)}
                              >
                                <MenuItem value={JSON.stringify(selectedField?.storedField?.value)}>
                                  {`Select ${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}`}
                                </MenuItem>

                                {selectedField?.storedField?.options?.map(
                                  (optionsItem, optionsItemIndex) => (
                                    <MenuItem
                                      key={`${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}_${selectedFieldIndex}_${optionsItemIndex}`}
                                      value={JSON.stringify(optionsItem)}
                                    >
                                      {selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'COUNTRY'
                                        ? optionsItem.countryName
                                        : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                            ?.fieldCode === 'STATE'
                                        ? optionsItem.stateName
                                        : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                            ?.fieldCode === 'CITY'
                                        ? optionsItem.cityName
                                        : optionsItem.defaultValueName}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </Box>
                          ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                              ?.typeCode === 'DATE' ? (
                            <div style={{ position: 'relative' }}>
                              {selectedField?.storedField !== null &&
                              (selectedField?.storedField?.value === null ||
                                selectedField?.storedField?.value === '' ||
                                selectedField?.storedField?.value === undefined) ? (
                                <span className="whenValue"> DD-MM-YYYY</span>
                              ) : (
                                ''
                              )}
                              <TextField
                                type="date"
                                fullWidth
                                id={
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId
                                }
                                inputProps={{ className: 'formControl' }}
                                placeholder={
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldName
                                }
                                onChange={(event) => {
                                  const prevData = journeyData;
                                  prevData[activeStep].selectedCards[wizItemIndex].secondaryCards[
                                    secondaryCardsItemIndex
                                  ].selectedFields[selectedFieldIndex].storedField.value =
                                    event.target.value;
                                  setJourneyData([...prevData]);
                                }}
                                value={
                                  selectedField?.storedField !== null
                                    ? selectedField?.storedField?.value !== null
                                      ? selectedField?.storedField?.value
                                      : ''
                                    : ''
                                }
                              />
                            </div>
                          ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                              ?.typeCode === 'NUMBER_FIELD' ? (
                            <TextField
                              type="number"
                              fullWidth
                              inputProps={{
                                className: 'formControl'
                              }}
                              id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                              placeholder={
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                              }
                              onChange={(event) => {
                                const prevData = journeyData;
                                prevData[activeStep].selectedCards[wizItemIndex].secondaryCards[
                                  secondaryCardsItemIndex
                                ].selectedFields[selectedFieldIndex].storedField.value =
                                  event.target.value;
                                setJourneyData([...prevData]);
                              }}
                              value={
                                selectedField?.storedField !== null
                                  ? selectedField?.storedField?.value !== null
                                    ? selectedField?.storedField?.value
                                    : ''
                                  : ''
                              }
                            />
                          ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                              ?.fieldCode === 'CAM_CARD_2_GST_PASSWORD' ? (
                            <TextField
                              fullWidth
                              type="password"
                              autoComplete="new-password"
                              inputProps={{
                                className: 'formControl'
                              }}
                              id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                              placeholder={
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                              }
                              onChange={(event) => {
                                const prevData = journeyData;
                                prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                  selectedFieldIndex
                                ].storedField.value = event.target.value;
                                setJourneyData([...prevData]);
                              }}
                              value={
                                selectedField?.storedField !== null
                                  ? selectedField?.storedField?.value !== null
                                    ? selectedField?.storedField?.value
                                    : ''
                                  : ''
                              }
                              InputProps={{
                                endAdornment:
                                  selectedField?.fieldCurrentIsOcrRequired !== null ? (
                                    selectedField?.fieldCurrentIsOcrRequired ? (
                                      <MdOutlineDocumentScanner color="#4fbbc8" />
                                    ) : selectedField.cardFieldMapping.fieldDefaultIsOcrRequired !==
                                      null ? (
                                      selectedField.cardFieldMapping.fieldDefaultIsOcrRequired ? (
                                        <MdOutlineDocumentScanner color="#4fbbc8" />
                                      ) : (
                                        ''
                                      )
                                    ) : (
                                      ''
                                    )
                                  ) : (
                                    ''
                                  )
                              }}
                            />
                          ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                              ?.fieldCode === 'CAM_CARD_2_MOBILE_PASSWORD' ? (
                            <TextField
                              fullWidth
                              type="password"
                              autoComplete="new-password"
                              inputProps={{
                                className: 'formControl'
                              }}
                              id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                              placeholder={
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                              }
                              onChange={(event) => {
                                const prevData = journeyData;
                                prevData[activeStep].selectedCards[wizItemIndex].selectedFields[
                                  selectedFieldIndex
                                ].storedField.value = event.target.value;
                                setJourneyData([...prevData]);
                              }}
                              value={
                                selectedField?.storedField !== null
                                  ? selectedField?.storedField?.value !== null
                                    ? selectedField?.storedField?.value
                                    : ''
                                  : ''
                              }
                              InputProps={{
                                endAdornment:
                                  selectedField?.fieldCurrentIsOcrRequired !== null ? (
                                    selectedField?.fieldCurrentIsOcrRequired ? (
                                      <MdOutlineDocumentScanner color="#4fbbc8" />
                                    ) : selectedField.cardFieldMapping.fieldDefaultIsOcrRequired !==
                                      null ? (
                                      selectedField.cardFieldMapping.fieldDefaultIsOcrRequired ? (
                                        <MdOutlineDocumentScanner color="#4fbbc8" />
                                      ) : (
                                        ''
                                      )
                                    ) : (
                                      ''
                                    )
                                  ) : (
                                    ''
                                  )
                              }}
                            />
                          ) : (
                            <TextField
                              fullWidth
                              inputProps={{
                                className: 'formControl'
                              }}
                              id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                              placeholder={
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                              }
                              onChange={(event) => {
                                const prevData = journeyData;
                                prevData[activeStep].selectedCards[wizItemIndex].secondaryCards[
                                  secondaryCardsItemIndex
                                ].selectedFields[selectedFieldIndex].storedField.value =
                                  event.target.value;
                                setJourneyData([...prevData]);
                              }}
                              value={
                                selectedField?.storedField !== null
                                  ? selectedField?.storedField?.value !== null
                                    ? selectedField?.storedField?.value
                                    : ''
                                  : ''
                              }
                            />
                          )}
                        </Grid>
                      )
                    ) : (
                      <Grid item xs={4}>
                        <Typography variant="body1" className="FormLabel">
                          {selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}

                          {selectedField?.fieldCurrentIsMendatory !== null ? (
                            selectedField?.fieldCurrentIsMendatory ? (
                              <Typography variant="span" color="error">
                                *
                              </Typography>
                            ) : selectedField.cardFieldMapping.fieldDefaultIsMendatory !== null ? (
                              selectedField.cardFieldMapping.fieldDefaultIsMendatory ? (
                                <Typography variant="span" color="error">
                                  *
                                </Typography>
                              ) : (
                                ''
                              )
                            ) : (
                              ''
                            )
                          ) : (
                            ''
                          )}
                        </Typography>
                        {selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                          ?.typeCode === 'DROPDOWN' ? (
                          <Box style={{ position: 'relative' }}>
                            <Select
                              fullWidth
                              inputProps={{
                                className: `formControl customSelectBox dissabledMenu${
                                  JSON.stringify(selectedField?.storedField?.value) === 'null'
                                    ? ' '
                                    : JSON.stringify(selectedField?.storedField?.value)
                                }`
                              }}
                              onChange={(event) => {
                                const inputData = JSON.parse(event.target.value);
                                const prevData = journeyData;
                                prevData[activeStep].selectedCards[wizItemIndex].secondaryCards[
                                  secondaryCardsItemIndex
                                ].selectedFields[selectedFieldIndex].storedField.value = inputData;
                                setJourneyData([...prevData]);
                                if (
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldCode === 'COUNTRY'
                                ) {
                                  stateCityAction(
                                    inputData.countryId,
                                    wizItemIndex,
                                    'STATE',
                                    countryListRes.allState,
                                    secondaryCardsItemIndex,
                                    ''
                                  );
                                } else if (
                                  selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldCode === 'STATE'
                                ) {
                                  stateCityAction(
                                    inputData.stateId,
                                    wizItemIndex,
                                    'CITY',
                                    countryListRes.allCity,
                                    secondaryCardsItemIndex,
                                    ''
                                  );
                                }
                              }}
                              value={JSON.stringify(selectedField?.storedField?.value)}
                            >
                              <MenuItem value={JSON.stringify(selectedField?.storedField?.value)}>
                                {`Select ${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}`}
                              </MenuItem>

                              {selectedField?.storedField?.options?.map(
                                (optionsItem, optionsItemIndex) => (
                                  <MenuItem
                                    key={`${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}_${selectedFieldIndex}_${optionsItemIndex}`}
                                    value={JSON.stringify(optionsItem)}
                                  >
                                    {selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                      ?.fieldCode === 'COUNTRY'
                                      ? optionsItem.countryName
                                      : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                          ?.fieldCode === 'STATE'
                                      ? optionsItem.stateName
                                      : selectedField?.cardFieldMapping?.journeyCardFieldsMaster
                                          ?.fieldCode === 'CITY'
                                      ? optionsItem.cityName
                                      : optionsItem.defaultValueName}
                                  </MenuItem>
                                )
                              )}
                            </Select>
                          </Box>
                        ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                            ?.typeCode === 'DATE' ? (
                          <div style={{ position: 'relative' }}>
                            {selectedField?.storedField !== null &&
                            (selectedField?.storedField?.value === null ||
                              selectedField?.storedField?.value === '' ||
                              selectedField?.storedField?.value === undefined) ? (
                              <span className="whenValue"> DD-MM-YYYY</span>
                            ) : (
                              ''
                            )}
                            <TextField
                              type="date"
                              fullWidth
                              id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                              inputProps={{ className: 'formControl' }}
                              placeholder={
                                selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                              }
                              onChange={(event) => {
                                const prevData = journeyData;
                                prevData[activeStep].selectedCards[wizItemIndex].secondaryCards[
                                  secondaryCardsItemIndex
                                ].selectedFields[selectedFieldIndex].storedField.value =
                                  event.target.value;
                                setJourneyData([...prevData]);
                              }}
                              value={
                                selectedField?.storedField !== null
                                  ? selectedField?.storedField?.value !== null
                                    ? selectedField?.storedField?.value
                                    : ''
                                  : ''
                              }
                            />
                          </div>
                        ) : selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                            ?.typeCode === 'NUMBER_FIELD' ? (
                          <TextField
                            type="number"
                            fullWidth
                            inputProps={{
                              className: 'formControl'
                            }}
                            id={`${selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}_${secondaryCardsItemIndex}`}
                            placeholder={
                              selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                            }
                            onChange={(event) => {
                              const prevData = journeyData;
                              prevData[activeStep].selectedCards[wizItemIndex].secondaryCards[
                                secondaryCardsItemIndex
                              ].selectedFields[selectedFieldIndex].storedField.value =
                                event.target.value;
                              setJourneyData([...prevData]);
                            }}
                            value={
                              selectedField?.storedField !== null
                                ? selectedField?.storedField?.value !== null
                                  ? selectedField?.storedField?.value
                                  : ''
                                : ''
                            }
                          />
                        ) : (
                          <TextField
                            fullWidth
                            inputProps={{
                              className: 'formControl'
                            }}
                            id={selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldId}
                            placeholder={
                              selectedField?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                            }
                            onChange={(event) => {
                              const prevData = journeyData;
                              prevData[activeStep].selectedCards[wizItemIndex].secondaryCards[
                                secondaryCardsItemIndex
                              ].selectedFields[selectedFieldIndex].storedField.value =
                                event.target.value;
                              setJourneyData([...prevData]);
                            }}
                            value={
                              selectedField?.storedField !== null
                                ? selectedField?.storedField?.value !== null
                                  ? selectedField?.storedField?.value
                                  : ''
                                : ''
                            }
                          />
                        )}
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            ))}
          </Grid>
        ))
      ) : (
        <Grid item xs="12" sm="6" md="6" mt={8}>
          {journeyData[activeStep]?.reviewCards.map((wizItem, index) => (
            <Box>
              <Typography
                variant="body1"
                className="headingLineUp headingLineUpOut"
                style={{ top: '-8px' }}
              >
                {wizItem.reviewCardHeading}
              </Typography>

              <Box className="viewLeadCard cardTopMinusMarginn" mb={3}>
                <Grid container spacing={3}>
                  {wizItem.selectedJourneyReviewCards.map((selectedJourneyReviewCardsItem) =>
                    selectedJourneyReviewCardsItem?.selectedJourneyCard?.masterCardModel?.cardType
                      ?.typeCode !== 'DOCUMENT'
                      ? selectedJourneyReviewCardsItem.reviewCardFields.map((reviewItem) => (
                          <Grid
                            item
                            xs={4}
                            key={`textOnly_${
                              reviewItem.reviewCardFieldHeading !== null
                                ? reviewItem?.reviewCardFieldHeading
                                : reviewItem?.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldName
                            }`}
                          >
                            <Box className="reviewEditIcon">
                              <Tooltip title="Edit Income Details">
                                <IconButton
                                  color="primary"
                                  className="squareIconButton"
                                  onClick={() => {
                                    const imgDetailsObj = {};
                                    setHelperTextMsg({ status: false, index: null });
                                    imgDetailsObj.src = wizItem?.reviewCardHeading;
                                    imgDetailsObj.alt =
                                      selectedJourneyReviewCardsItem?.reviewCardFields;
                                    imgDetailsObj.contentType = 'isReviewCardEditable';
                                    docPrevHandler('open', JSON.stringify(imgDetailsObj), index);
                                  }}
                                  disabled={!wizItem.isReviewCardEditable}
                                >
                                  <AiFillEdit size={18} />
                                </IconButton>
                              </Tooltip>
                            </Box>
                            <Box className="displayFlex">
                              {reviewItem.reviewCardFieldIcon !== null &&
                              reviewItem.reviewCardFieldIcon !== undefined &&
                              reviewItem.reviewCardFieldIcon !== '' ? (
                                <img
                                  style={{
                                    width: '45px',
                                    marginRight: '15px',
                                    borderRadius: '5px'
                                  }}
                                  src={reviewItem.reviewCardFieldIcon}
                                  alt=""
                                />
                              ) : (
                                ''
                              )}
                              <Box>
                                <Typography
                                  variant="body2"
                                  className="labelText"
                                  sx={{ display: 'flex', alignItems: 'center' }}
                                >
                                  {reviewItem.reviewCardFieldHeading !== null
                                    ? reviewItem?.reviewCardFieldHeading
                                    : reviewItem?.cardDetail?.cardFieldMapping
                                        ?.journeyCardFieldsMaster?.fieldName}
                                  {reviewItem?.cardDetail?.isEdited ? (
                                    <Tooltip title="Edited">
                                      <Box ml={0.5} mt={0.5}>
                                        <MdInfo size={14} />
                                      </Box>
                                    </Tooltip>
                                  ) : (
                                    ''
                                  )}
                                </Typography>
                                <Typography variant="subtitle2" className="labelValue">
                                  {reviewItem?.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldType?.typeCode === 'DROPDOWN'
                                    ? reviewItem?.cardDetail?.cardFieldMapping
                                        ?.journeyCardFieldsMaster?.fieldCode === 'STATE'
                                      ? reviewItem?.cardDetail?.storedField?.value?.stateName
                                      : reviewItem?.cardDetail?.cardFieldMapping
                                          ?.journeyCardFieldsMaster?.fieldCode === 'CITY'
                                      ? reviewItem?.cardDetail?.storedField?.value?.cityName
                                      : reviewItem?.cardDetail?.cardFieldMapping
                                          ?.journeyCardFieldsMaster?.fieldCode === 'COUNTRY'
                                      ? reviewItem?.cardDetail?.storedField?.value?.countryName
                                      : reviewItem?.cardDetail?.storedField?.value?.defaultValueName
                                      ? reviewItem?.cardDetail?.storedField?.value?.defaultValueName
                                      : 'Not Available'
                                    : reviewItem?.cardDetail?.storedField !== null
                                    ? reviewItem?.cardDetail?.storedField?.value
                                    : 'Not Available'}
                                  {/* original code */}
                                  {/* {reviewItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster
                                    .fieldType.typeCode === 'DROPDOWN'
                                    ? reviewItem?.storedField !== null
                                      ? reviewItem?.cardDetail?.storedField?.value?.defaultValueName
                                      : 'N/A'
                                    : reviewItem?.cardDetail?.storedField !== null
                                    ? reviewItem?.cardDetail?.storedField?.value
                                    : 'N/A'} */}
                                </Typography>
                              </Box>
                            </Box>
                          </Grid>
                        ))
                      : selectedJourneyReviewCardsItem.reviewCardFields.map(
                          (reviewItem, reviewIndex) => {
                            console.log(
                              'cddddddddddddddd',
                              reviewItem.reviewCardFieldHeading !== null
                                ? reviewItem?.reviewCardFieldHeading
                                : reviewItem?.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldName
                            );
                            return (
                              <Box
                                className="displayFlex flexWrap"
                                ml={reviewIndex === 0 ? 3 : ''}
                                mt={4}
                                key={`documentOnly_${
                                  reviewItem.reviewCardFieldHeading !== null
                                    ? reviewItem?.reviewCardFieldHeading
                                    : reviewItem?.cardDetail?.cardFieldMapping
                                        ?.journeyCardFieldsMaster?.fieldName
                                }`}
                              >
                                {reviewItem?.cardDetail?.storedField !== null
                                  ? reviewItem?.cardDetail?.storedField?.documentMap !== null &&
                                    reviewItem?.cardDetail?.storedField?.documentMap !== '' &&
                                    reviewItem?.cardDetail?.storedField?.documentMap !==
                                      undefined &&
                                    Object.keys(reviewItem?.cardDetail?.storedField?.documentMap)
                                      .length !== 0
                                    ? Object.keys(
                                        reviewItem?.cardDetail?.storedField?.documentMap
                                      ).map((documentMapItem, documentMapIndex) => (
                                        <Box
                                          className="uploadFilePreviewBox uploadFilePreviewGreen"
                                          onClick={() => {
                                            const imgDetailsObj = {};
                                            imgDetailsObj.src =
                                              reviewItem?.cardDetail?.storedField?.documentMap[
                                                documentMapItem
                                              ].path;
                                            imgDetailsObj.alt =
                                              reviewItem.reviewCardFieldHeading !== null
                                                ? reviewItem?.reviewCardFieldHeading
                                                : reviewItem?.cardDetail?.cardFieldMapping
                                                    ?.journeyCardFieldsMaster?.fieldName;
                                            imgDetailsObj.contentType =
                                              reviewItem?.cardDetail?.storedField?.documentMap[
                                                documentMapItem
                                              ].contentType;
                                            docPrevHandler(
                                              'open',
                                              JSON.stringify(imgDetailsObj),
                                              index
                                            );
                                          }}
                                        >
                                          <RemoveRedEyeIcon className="ImageViewIcon" />
                                          <Typography variant="body2" className="docName">
                                            {documentMapItem === 'frontFace'
                                              ? `${
                                                  reviewItem.reviewCardFieldHeading !== null
                                                    ? reviewItem?.reviewCardFieldHeading
                                                    : reviewItem?.cardDetail?.cardFieldMapping
                                                        ?.journeyCardFieldsMaster?.fieldName
                                                }`
                                              : `Back ${
                                                  reviewItem.reviewCardFieldHeading !== null
                                                    ? reviewItem?.reviewCardFieldHeading
                                                    : reviewItem?.cardDetail?.cardFieldMapping
                                                        ?.journeyCardFieldsMaster?.fieldName
                                                }`}
                                          </Typography>
                                        </Box>
                                      ))
                                    : ''
                                  : ''}
                              </Box>
                            );
                          }
                        )
                  )}
                </Grid>
              </Box>
            </Box>
          ))}
        </Grid>
      )}

      <Dialog
        className="PopupBox"
        open={docPrevFlag.flag}
        onClose={() => docPrevHandler('close', '', null)}
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="popupHeadingg">
          <Typography variant="h6" className="popupTitlee">
            {docPrevFlag.contentType === 'content'
              ? 'Document Size Error '
              : docPrevFlag.contentType === 'validation'
              ? 'Required Fields'
              : docPrevFlag.contentType === 'mobilenoValidation'
              ? 'Director Mobile validation'
              : docPrevFlag.contentType === 'isReviewCardEditable'
              ? `Edit ${docPrevFlag.srcPath}`
              : 'Document Preview'}
          </Typography>

          <IconButton onClick={() => docPrevHandler('close', '', null)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers className="PopupContent">
          <DialogContentText>
            {docPrevFlag.contentType === 'content' || docPrevFlag.contentType === 'validation' ? (
              docPrevFlag.imgaltTag
            ) : docPrevFlag.contentType === 'application/pdf' ? (
              <Document
                file={docPrevFlag.srcPath}
                onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
              >
                <Pages pageNumber={pageNumber} />
              </Document>
            ) : docPrevFlag.contentType === 'mobilenoValidation' ? (
              docPrevFlag.imgaltTag
            ) : docPrevFlag.contentType === 'isReviewCardEditable' ? (
              <Grid container spacing={{ xs: 1, sm: 2, md: 3 }} mb={3}>
                {docPrevFlag.imgaltTag?.length > 0
                  ? docPrevFlag.imgaltTag.map((item, index) => {
                      console.log('helperTextMsg-111', helperTextMsg, helperTextMsg.index);

                      return (
                        <Grid item xs={12} sm={6} md={4}>
                          <FormControl required fullWidth className="formGroup">
                            <Typography variant="body1" className="FormLabel">
                              {item.reviewCardFieldHeading}
                              {/* mandatory * code starts here */}

                              {item?.cardDetail?.fieldCurrentIsMendatory !== null ? (
                                item?.cardDetail?.fieldCurrentIsMendatory ? (
                                  <Typography variant="span" color="error">
                                    *
                                    {helperTextMsg.status === true &&
                                    helperTextMsg.index === index ? (
                                      <FormHelperText error>Please enter value</FormHelperText>
                                    ) : (
                                      ''
                                    )}
                                  </Typography>
                                ) : item?.cardDetail?.cardFieldMapping?.fieldDefaultIsMendatory !==
                                  null ? (
                                  item?.cardDetail?.cardFieldMapping?.fieldDefaultIsMendatory ? (
                                    <Typography variant="span" color="error">
                                      *
                                      {helperTextMsg.status === true &&
                                      helperTextMsg.index === index ? (
                                        <FormHelperText error>Please enter value</FormHelperText>
                                      ) : (
                                        ''
                                      )}
                                    </Typography>
                                  ) : (
                                    ''
                                  )
                                ) : (
                                  ''
                                )
                              ) : (
                                ''
                              )}
                            </Typography>
                            {/* mandatory code ends here */}

                            {item.cardDetail.cardFieldMapping?.journeyCardFieldsMaster?.fieldType
                              ?.typeCode === 'DROPDOWN' ? (
                              <Select
                                fullWidth
                                disabled={!item.isReviewCardFieldEditable}
                                inputProps={{
                                  className: `formControl customSelectBox dissabledMenu${
                                    JSON.stringify(item.cardDetail?.storedField?.value) === 'null'
                                      ? ' '
                                      : JSON.stringify(item.cardDetail?.storedField?.value)
                                  }`
                                }}
                                onChange={(event) => {
                                  const inputData = JSON.parse(event.target.value);
                                  const prevDataNew = docPrevFlag.imgaltTag;
                                  prevDataNew[index].cardDetail.storedField.value = inputData;
                                  prevDataNew[index].cardDetail.isEdited = true;
                                  setReviewItemData([...prevDataNew]);
                                  if (
                                    item.cardDetail.cardFieldMapping?.journeyCardFieldsMaster
                                      ?.fieldCode === 'COUNTRY'
                                  ) {
                                    stateCityAction(
                                      inputData.countryId,
                                      index,
                                      'STATE',
                                      countryListRes.allState,
                                      '',
                                      [...prevDataNew]
                                    );
                                  } else if (
                                    item.cardDetail.cardFieldMapping?.journeyCardFieldsMaster
                                      ?.fieldCode === 'STATE'
                                  ) {
                                    stateCityAction(
                                      inputData.stateId,
                                      index,
                                      'CITY',
                                      countryListRes.allCity,
                                      '',
                                      [...prevDataNew]
                                    );
                                    loantyprapiFire('cityList', inputData.stateId, '', '', '');
                                  }
                                }}
                                value={JSON.stringify(item.cardDetail?.storedField?.value)}
                              >
                                <MenuItem
                                  value={JSON.stringify(item.cardDetail?.storedField?.value)}
                                >
                                  {`Select ${item.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}`}
                                </MenuItem>

                                {item.cardDetail?.storedField?.options?.map(
                                  (optionsItem, optionsItemIndex) => (
                                    <MenuItem
                                      key={`${item.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName}_${index}_${optionsItemIndex}`}
                                      value={JSON.stringify(optionsItem)}
                                    >
                                      {item.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                        ?.fieldCode === 'COUNTRY'
                                        ? optionsItem.countryName
                                        : item.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                            ?.fieldCode === 'STATE'
                                        ? optionsItem.stateName
                                        : item.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                            ?.fieldCode === 'CITY'
                                        ? optionsItem.cityName
                                        : optionsItem.defaultValueName}
                                      {/* optionsItem.cityName} */}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            ) : item.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                ?.fieldType?.typeCode === 'DATE' ? (
                              <div style={{ position: 'relative' }}>
                                {item.cardDetail?.storedField !== null &&
                                (item.cardDetail?.storedField?.value === null ||
                                  item.cardDetail?.storedField?.value === '' ||
                                  item.cardDetail?.storedField?.value === undefined) ? (
                                  <span className="whenValue"> DD-MM-YYYY</span>
                                ) : (
                                  ''
                                )}
                                <TextField
                                  type="date"
                                  disabled={!item.isReviewCardFieldEditable}
                                  fullWidth
                                  id={
                                    item.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                      ?.fieldId
                                  }
                                  inputProps={{ className: 'formControl' }}
                                  placeholder={
                                    item.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                      ?.fieldName
                                  }
                                  onChange={(event) => {
                                    const prevDataNew = docPrevFlag.imgaltTag;
                                    prevDataNew[index].cardDetail.storedField.value =
                                      event.target.value;
                                    prevDataNew[index].cardDetail.isEdited = true;
                                    setReviewItemData([...prevDataNew]);
                                  }}
                                  value={
                                    item.cardDetail?.storedField !== null &&
                                    item.cardDetail?.storedField?.value !== null
                                      ? item.cardDetail?.storedField?.value
                                      : ''
                                  }
                                />
                              </div>
                            ) : item.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                ?.fieldType?.typeCode === 'NUMBER_FIELD' ? (
                              <TextField
                                type="number"
                                disabled={!item.isReviewCardFieldEditable}
                                fullWidth
                                inputProps={{
                                  className: 'formControl'
                                }}
                                id={
                                  item.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldId
                                }
                                placeholder={
                                  item.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldName
                                }
                                onChange={(event) => {
                                  const prevDataNew = docPrevFlag.imgaltTag;

                                  prevDataNew[index].cardDetail.storedField.value =
                                    event.target.value;
                                  prevDataNew[index].cardDetail.isEdited = true;
                                  setReviewItemData([...prevDataNew]);
                                }}
                                value={
                                  item.cardDetail?.storedField !== null &&
                                  item.cardDetail?.storedField?.value !== null &&
                                  item.cardDetail?.storedField?.value !== 'Not Available'
                                    ? item.cardDetail?.storedField?.value
                                    : ''
                                }
                              />
                            ) : (
                              <TextField
                                fullWidth
                                disabled={!item.isReviewCardFieldEditable}
                                inputProps={{
                                  className: 'formControl'
                                }}
                                id={
                                  item.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldId
                                }
                                placeholder={
                                  item.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                                    ?.fieldName
                                }
                                onChange={(event) => {
                                  const prevDataNew = docPrevFlag.imgaltTag;

                                  prevDataNew[index].cardDetail.storedField.value =
                                    event.target.value;
                                  prevDataNew[index].cardDetail.isEdited = true;
                                  setReviewItemData([...prevDataNew]);
                                }}
                                value={
                                  item.cardDetail?.storedField !== null &&
                                  item.cardDetail?.storedField?.value !== null &&
                                  item.cardDetail?.storedField?.value !== 'Not Available'
                                    ? item.cardDetail?.storedField?.value
                                    : ''
                                }
                              />
                            )}
                          </FormControl>
                        </Grid>
                      );
                    })
                  : ''}
              </Grid>
            ) : (
              <img src={docPrevFlag.srcPath} alt={docPrevFlag.imgaltTag} />
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="mainBtn"
            onClick={() => {
              if (docPrevFlag.contentType === 'isReviewCardEditable') {
                let allowToFireApi = true;
                const prevDataX = docPrevFlag.imgaltTag;
                prevDataX.every((selectedFieldsItemReview, index1) => {
                  if (selectedFieldsItemReview.cardDetail.fieldCurrentIsMendatory) {
                    const imgDetailsObj = {};
                    imgDetailsObj.src = '';
                    imgDetailsObj.alt =
                      selectedFieldsItemReview.cardDetail.cardFieldMapping.journeyCardFieldsMaster.fieldName;
                    imgDetailsObj.contentType = 'validation';
                    if (
                      selectedFieldsItemReview.cardDetail.cardFieldMapping?.journeyCardFieldsMaster
                        ?.fieldType?.typeCode !== 'DOCUMENT'
                    ) {
                      if (
                        selectedFieldsItemReview.cardDetail.storedField.value === null ||
                        selectedFieldsItemReview.cardDetail.storedField.value === ''
                      ) {
                        setHelperTextMsg({ status: true, index: index1 });
                        allowToFireApi = false;
                      }
                    } else if (
                      selectedFieldsItemReview.cardDetail.cardFieldMapping?.journeyCardFieldsMaster
                        ?.fieldType?.typeCode === 'DOCUMENT'
                    ) {
                      if (selectedFieldsItemReview.cardDetail.storedField !== null) {
                        if (
                          selectedFieldsItemReview.cardDetail.storedField.documentMap === null &&
                          selectedFieldsItemReview.cardDetail?.storedField?.documentMap !== '' &&
                          selectedFieldsItemReview.cardDetail?.storedField?.documentMap !==
                            undefined &&
                          Object.keys(selectedFieldsItemReview.cardDetail?.storedField?.documentMap)
                            .length !== 0
                        ) {
                          setHelperTextMsg({ status: true, index: index1 });
                          allowToFireApi = false;
                        }
                      } else {
                        setHelperTextMsg({ status: true, index: index1 });
                        allowToFireApi = false;
                      }
                    }
                  }
                  return allowToFireApi;
                });

                if (allowToFireApi === true && reviewItemData !== null) {
                  loantyprapiFire('reviewEditUpdate', reviewItemData, '', '', '');
                } else if (reviewItemData === null) {
                  docPrevHandler('close', '', null);
                }
              } else {
                docPrevHandler('close', '', null);
              }
            }}
          >
            {docPrevFlag.contentType === 'isReviewCardEditable'
              ? // ? `Update ${docPrevFlag.srcPath}`
                'Update'
              : 'Close'}
          </Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ display: 'flex' }}>
        {activeStep > 0 ? (
          <Button
            onClick={() => finishJourney('onlyBack')}
            startIcon={<HiOutlineArrowNarrowLeft />}
            className="mainBtn previousBtn"
          >
            Back
          </Button>
        ) : (
          ''
        )}

        {journeyData.length - 1 === activeStep ? (
          <Button
            onClick={() => finishJourney('finish')}
            className="mainBtn"
            variant="contained nextBtn"
          >
            Finish
          </Button>
        ) : (
          <Button
            onClick={() => {
              let allowToFireApi = true;
              const prevDataX = journeyData;
              prevDataX[activeStep].selectedCards.every((selectedCardsItem) => {
                selectedCardsItem.selectedFields.every((selectedFieldsItem) => {
                  if (selectedFieldsItem.fieldCurrentIsMendatory) {
                    const imgDetailsObj = {};
                    imgDetailsObj.src = '';
                    imgDetailsObj.alt =
                      selectedFieldsItem.cardFieldMapping.journeyCardFieldsMaster.fieldName;
                    imgDetailsObj.contentType = 'validation';
                    if (selectedCardsItem.masterCardModel.cardType.typeCode !== 'DOCUMENT') {
                      if (
                        selectedFieldsItem.storedField.value === null ||
                        selectedFieldsItem.storedField.value === ''
                      ) {
                        docPrevHandler('open', JSON.stringify(imgDetailsObj), null);
                        allowToFireApi = false;
                      }
                    } else if (selectedCardsItem.masterCardModel.cardType.typeCode === 'DOCUMENT') {
                      if (selectedFieldsItem.storedField !== null) {
                        if (
                          selectedFieldsItem.storedField.documentMap === null &&
                          selectedFieldsItem?.storedField?.documentMap !== '' &&
                          selectedFieldsItem?.storedField?.documentMap !== undefined &&
                          Object.keys(selectedFieldsItem?.storedField?.documentMap).length !== 0
                        ) {
                          docPrevHandler('open', JSON.stringify(imgDetailsObj), null);
                          allowToFireApi = false;
                        }
                      } else {
                        docPrevHandler('open', JSON.stringify(imgDetailsObj), null);
                        allowToFireApi = false;
                      }
                    }
                  }
                  return allowToFireApi;
                });
                return allowToFireApi;
              });

              if (allowToFireApi === true) {
                finishJourney('onlyNext');
              }
            }}
            className="mainBtn"
            endIcon={<HiOutlineArrowNarrowRight />}
            variant="contained nextBtn"
          >
            Next
          </Button>
        )}
      </Box>
    </>
  );
}

export default RecommendationApplication;

function ShowInputBox({ val }) {
  useEffect(() => {}, [val]);
  console.log('valval', val);
  return (
    <TextField
      value={val}
      inputProps={{ className: 'TextField', readOnly: true }}
      className="TextFieldGroup"
    />
  );
}
